import React, { useEffect, /*useContext,*/ useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../../utils/tokenVerify";
// import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import { Table, Tooltip, Radio, Select, Col, Row, Pagination, Input, Checkbox, Button, Spin, Modal } from 'antd';
// import columnIcon from '../../assets/images/icons/column.svg'
import HoverCloseIcon from '../../assets/images/icons/hover_close.svg';
import macrosicon from '../../assets/images/icons/macros_modal_icon.svg';
// import tagRomoveIcon from '../../assets/images/icons/tag_close_icon.svg';
// import filterIcon from '../../assets/images/icons/filter.svg';
import mediaKitIcon from '../../assets/images/icons/export_download_icon.svg';
// import ExportIcon from '../../assets/images/icons/export_icon.svg';
import { Link } from 'react-router-dom'
import uploadCloudIcon from '../../assets/images/icons/upload_cloud_icon.svg';
import FullLoader from "../../assets/images/full-page-loader.gif"
import csvIcon from '../../assets/images/icons/csv.svg';
import txtIcon from '../../assets/images/icons/txt.svg';
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import infoIcon from '../../assets/images/icons/info.svg';
import noData from '../../assets/images/data-graph/no-data.svg';
import { CSVLink } from "react-csv";
import TableLoader from "../TableLoader";
import AddCodesAdd from '../../assets/images/icons/add_codes_add.svg';
import AddCodesMinus from '../../assets/images/icons/ad_codes_minus.svg';
import errorData from '../../assets/images/data-graph/error-data.svg';
import uploadFileIcon from '../../assets/images/icons/upload_file_icon.svg';
import Dropdown from 'react-bootstrap/Dropdown';
// import DateRangePicker from 'react-bootstrap-daterangepicker';
// import moment from 'moment';
// import RangeCalendar from '../../assets/images/icons/range-calendar.svg';
import { SearchOutlined/*, setTwoToneColor*/ } from '@ant-design/icons';
import addIcon from '../../assets/images/addbtnicon/plusicon.svg';
import removeIcon from '../../assets/images/icons/minus_circle_remove_ icon.svg';
import { jwtDecode } from "jwt-decode";
import { notifyfailure, notifysuccess, notifycatch } from "../../utils/toast";
import { saveAs } from "file-saver";
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import AdsTxtSvg from '../../assets/images/icons/ads_txt_svg.svg';
import csvImage from '../../assets/images/icons/csv_image.svg';
import downloadCsvIcon from '../../assets/images/icons/download_csv_icon.svg';
import iconProcessingRequest from '../../assets/images/icons/icon_processing_request.svg';
import taggingPremiumIcon from '../../assets/images/icons/tagging_premium.svg';
import taggingBlacklistIcon from '../../assets/images/icons/tagging_blacklist.svg';
import taggingGoodIcon from '../../assets/images/icons/tagging_good.svg';
import taggingLowIcon from '../../assets/images/icons/tagging_low.svg';
import taggingBlockedIcon from '../../assets/images/icons/tagging_blocked.svg';
import taggingDirectIcon from '../../assets/images/icons/tagging_direct.svg';
import taggingNoTagIcon from '../../assets/images/icons/tagging_notag.svg';
import historyButton from '../../assets/images/icons/history_button.svg';
import ExportWithChild from '../../assets/images/icons/export_with_child.svg';
import ExportMenu1 from '../../assets/images/icons/export_menu_1.svg';
import ExportMenu2 from '../../assets/images/icons/export_menu_2.svg';
import AddNewAdcodesImg from '../../assets/images/icons/add_new_adcodes.svg';


const { Option } = Select;

const MediaPlanner = () => {

    //modal opening macros  ------
    const [modalCountryRequest_Preview, setModalCountryRequest_preview] = useState([]);
    const [modalCountryRequest_Preview_Type, setModalCountryRequest_preview_Type] = useState("");
    const [isModalVisibleCountryRequest, setIsModalVisibleCountryRequest] = useState(false);

    const closeModalCountryRequest = () => {
        setIsModalVisibleCountryRequest(false);
        setModalCountryRequest_preview([])
        setModalCountryRequest_preview_Type("")
    };



    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    // const loadingContext = useContext(LoadingContext);
    const [apiCall, setApicall] = useState(false)

    const isIndeterminate = (colvis) => {
        const values = Object.values(colvis);
        return values.some(value => value) && !values.every(value => value);
    };

    const [colvis, setColvis] = useState({
        "adcodes": true,
        "m_lang": true,
        "m_words": true,
        "m_desc": true,
        "tld_co": true,
        "gpt_cat": true,
        "gpt_geo": true,
        "gpt_bs": true,
        "pub_req": true,
        "co_req": true,
        "insertedDate": true,
        "updated": true,
        "err": true,
        "err_msg": true,
    })
    const [filterRepeaterValueOptions_colvis] = useState([
        { label: "Ad codes", value: "adcodes" },
        { label: "Language (Meta)", value: "m_lang" },
        { label: "Keywords (Meta)", value: "m_words" },
        { label: "Description (Meta)", value: "m_desc" },
        { label: "Country (TLD)", value: "tld_co" },
        { label: "Categories (GPT)", value: "gpt_cat" },
        { label: "Country (GPT)", value: "gpt_geo" },
        { label: "Brand Safety (GPT)", value: "gpt_bs" },
        { label: "Publisher Request", value: "pub_req" },
        { label: "Country Wise Request", value: "co_req" },
        { label: "Inserted Date", value: "insertedDate" },
        { label: "Updated At", value: "updated" },
        { label: "Error", value: "err" },
        { label: "Error Message", value: "err_msg" },

    ])
    const [colvisLength] = useState(11)
    const [filterDropdowns, setFilterDropdowns] = useState([])
    const [columnsAll, setColumnsAll] = useState([
        {
            title: 'URL',
            dataIndex: 'url',
            width: 300,
            key: 'url',
            fixed: 'left',
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (data, record) => {

                return (
                    <>
                        {(data === "" || data === undefined || data === null) ?
                            <>
                                <div className='text_dark'>-</div>
                            </>
                            :
                            <>
                                <div className="main_div_tagging_list">
                                    {data.length >= 28 ?
                                        <Tooltip title={data}><div className='domain_cursor d-block anchor_tag_d2' style={{ cursor: "pointer" }}><a href={data.includes("https://") ? data : "https://" + data} className="anchor_text_link_d2" target="_blank" rel="noreferrer">{data.slice(0, 28)}...</a></div></Tooltip> :
                                        <div className='text_ellipsis d-block anchor_tag_d2'

                                        ><a href={data.includes("https://") ? data : "https://" + data} className="domain_cursor anchor_text_link_d2" target="_blank" rel="noreferrer">{data}</a></div>
                                    }



                                    {(record.ads_txt_url === "" || record.ads_txt_url === undefined || record.ads_txt_url === null) ?
                                        <></> :
                                        <div className="overlay-link" >
                                            <a href={record.ads_txt_url} target="_blank" rel="noreferrer">

                                                <img src={AdsTxtSvg} alt="" />

                                            </a>
                                        </div>
                                    }

                                    {record.tags !== undefined &&
                                        <>
                                            {record.tags.length > 1 ?

                                                <Tooltip title={record.tags.join(", ")}>
                                                    <div style={{ position: "relative" }}>
                                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.587 6.706L7.287 0.406C7.028 0.147 6.671 0 6.3 0H1.4C0.63 0 0 0.63 0 1.4V6.3C0 6.671 0.147 7.028 0.413 7.287L0.7 7.567C1.33 7.189 2.058 7 2.8 7C5.117 7 7 8.883 7 11.2C7 11.942 6.804 12.663 6.426 13.3L6.706 13.58C6.965 13.846 7.329 14 7.7 14C8.071 14 8.428 13.853 8.687 13.587L13.587 8.687C13.853 8.428 14 8.071 14 7.7C14 7.329 13.853 6.972 13.587 6.706ZM2.45 3.5C1.869 3.5 1.4 3.031 1.4 2.45C1.4 1.869 1.869 1.4 2.45 1.4C3.031 1.4 3.5 1.869 3.5 2.45C3.5 3.031 3.031 3.5 2.45 3.5Z" fill="#00AE91" />
                                                        </svg>
                                                        <p style={{
                                                            position: "absolute", top: "10px", left: "1px",
                                                            color: "#005AAE",
                                                            fontFamily: "Poppins",
                                                            fontSize: "8px",
                                                            fontWeight: "600",
                                                            lineHeight: "11px",

                                                        }}>{record.tags.length}</p>
                                                    </div>

                                                </Tooltip>
                                                :
                                                record.tags.length === 1 && record.tags[0] !== "No Tag" ?
                                                    record.tags[0] === "Premium" ?
                                                        <Tooltip title="Premium">
                                                            <img src={taggingPremiumIcon} alt="" />
                                                        </Tooltip>
                                                        :
                                                        record.tags[0] === "Good" ?
                                                            <Tooltip title="Good">
                                                                <img src={taggingGoodIcon} alt="" />
                                                            </Tooltip>
                                                            :
                                                            record.tags[0] === "Low" ?
                                                                <Tooltip title="Low">
                                                                    <img src={taggingLowIcon} alt="" />
                                                                </Tooltip>
                                                                :
                                                                record.tags[0] === "Blacklist" ?
                                                                    <Tooltip title="Blacklist">
                                                                        <img src={taggingBlacklistIcon} alt="" />
                                                                    </Tooltip>
                                                                    :
                                                                    record.tags[0] === "Blocked" ?
                                                                        <Tooltip title="Blocked">
                                                                            <img src={taggingBlockedIcon} alt="" />
                                                                        </Tooltip>
                                                                        :
                                                                        record.tags[0] === "Direct" ?
                                                                            <Tooltip title="Direct">
                                                                                <img src={taggingDirectIcon} alt="" />
                                                                            </Tooltip>
                                                                            :
                                                                            <></>
                                                    :
                                                    <>
                                                    </>
                                            }
                                        </>
                                    }

                                </div>

                            </>

                        }

                    </>
                )
            },

        },
        {
            title: 'Ad codes',
            dataIndex: 'adcodes',
            width: 250,
            key: 'adcodes',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip
                                    overlayInnerStyle={{
                                        width: "500px",
                                        maxHeight: "150px",
                                        height: "auto",
                                        overflowY: 'auto', // Enable scrolling for overflow content
                                        overflowX: 'hidden',
                                    }}
                                    title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Language (Meta)',
            dataIndex: 'm_lang',
            width: 150,
            key: 'm_lang',
            render: (data) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 15 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )
            }
        },
        {
            title: 'Keywords (Meta)',
            dataIndex: 'm_words',
            width: 250,
            key: 'm_words',
            render: (data) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null || Object.keys(data).length === 0) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip
                                    overlayInnerStyle={{
                                        width: "500px",
                                        maxHeight: "150px",
                                        height: "auto",
                                        overflowY: 'auto', // Enable scrolling for overflow content
                                        overflowX: 'hidden',
                                    }}
                                    title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )
            }
        },
        {
            title: 'Description (Meta)',
            dataIndex: 'm_desc',
            width: 250,
            key: 'm_desc',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip
                                    overlayInnerStyle={{
                                        width: "500px",
                                        maxHeight: "150px",
                                        height: "auto",
                                        overflowY: 'auto', // Enable scrolling for overflow content
                                        overflowX: 'hidden',
                                    }}
                                    title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Country (TLD)',
            dataIndex: 'tld_co',
            width: 170,
            key: 'tld_co',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 17 ?
                                <Tooltip title={data}><div className=' d-block' style={{ cursor: "pointer" }}>{data.slice(0, 17)} ...</div></Tooltip> :
                                <div className='d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Categories (GPT)',
            dataIndex: 'gpt_cat',
            width: 250,
            key: 'gpt_cat',
            render: (data, record) => {
                const display = Array.isArray(data)
                    ? data.length > 0
                        ? data.join(',')
                        : '-'
                    : "";



                return (
                    <>
                        {(display === "" || display === "-" || display === undefined || display === null) ? <><div className='text_dark'>-</div></> :
                            display.length >= 30 ?
                                <Tooltip title={display}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{display}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{display}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Country (GPT)',
            dataIndex: 'gpt_geo',
            width: 250,
            key: 'gpt_geo',
            render: (data, record) => {
                const display = Array.isArray(data)
                    ? data.length > 0
                        ? data.join(',')
                        : '-'
                    : "";


                return (
                    <>
                        {(display === "" || display === "-" || display === undefined || display === null) ? <><div className='text_dark'>-</div></> :
                            display.length >= 30 ?
                                <Tooltip title={display}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{display}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{display}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Brand Safety (GPT)',
            dataIndex: 'gpt_bs',
            width: 150,
            key: 'gpt_bs',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Publisher Request',
            dataIndex: 'pub_req',
            width: 150,
            key: 'pub_req',
            render: (data, record) => {
                return (
                    <>
                        {addCommasToNumber(data)}
                    </>
                )

            },
        },
        {
            title: 'Country Wise Request',
            dataIndex: 'co_req',
            width: 160,
            key: 'co_req',
            render: (data, record) => {
                const display = Object.entries(data)?.map(([country, value]) => ({
                    country: country,
                    value: value
                }));
                return (
                    <>
                        {(Object.keys(data).length === 0 && data !== undefined) ? <><div className='text_dark'>-</div></> :
                            <div className='anchor_text_link_d2' onClick={() => {
                                setIsModalVisibleCountryRequest(true);
                                setModalCountryRequest_preview(display)
                            }
                            } >View</div>
                        }
                    </>
                )

            },
        },

        // {
        //     title: 'Categories (PX)',
        //     dataIndex: 'px_cat',
        //     width: 250,
        //     key: 'px_cat',
        //     render: (data, record) => {
        //         const display = Array.isArray(data)
        //             ? data.length > 0
        //                 ? data.join(',')
        //                 : '-'
        //             : "";
        //         return (
        //             <>
        //                 {(display === "" || display === "-" || display === undefined || display === null) ? <><div className='text_dark'>-</div></> :
        //                     display.length >= 30 ?
        //                         <Tooltip title={display}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{display}</div></Tooltip> :
        //                         <div className='text_ellipsis d-block' >{display}</div>
        //                 }
        //             </>
        //         )

        //     },
        // },

        // {
        //     title: 'Sub Categories (PX)',
        //     dataIndex: 'px_scat',
        //     width: 250,
        //     key: 'px_scat',
        //     render: (data, record) => {
        //         const display = Array.isArray(data)
        //             ? data.length > 0
        //                 ? data.join(',')
        //                 : '-'
        //             : "";
        //         return (
        //             <>
        //                 {(display === "" || display === "-" || display === undefined || display === null) ? <><div className='text_dark'>-</div></> :
        //                     display.length >= 30 ?
        //                         <Tooltip title={display}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{display}</div></Tooltip> :
        //                         <div className='text_ellipsis d-block' >{display}</div>
        //                 }
        //             </>
        //         )

        //     },
        // },
        // {
        //     title: 'Owner Domain (PX)',
        //     dataIndex: 'px_owner',
        //     width: 250,
        //     key: 'px_owner',
        //     render: (data, record) => {
        //         return (
        //             <div style={{ display: "flex", flexDirection: "column" }}>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data.length >= 30 ?
        //                             <Tooltip title={data}><div className='text_ellipsis d-block anchor_tag_d2' style={{ cursor: "pointer" }}><a href={data.includes("https://") ? data : "https://" + data} className="anchor_text_link_d2" target="_blank">{data}</a></div></Tooltip> :
        //                             <div className='text_ellipsis d-block anchor_tag_d2'><a href={data.includes("https://") ? data : "https://" + data} className="anchor_text_link_d2" target="_blank">{data}</a></div>
        //                         }
        //                         {
        //                             record.ads_txt_url !== "" && record.ads_txt_url !== undefined && record.ads_txt_url === null &&
        //                             <br />
        //                         }

        //                     </>

        //                 }
        //             </div>
        //         )
        //     },
        // },
        // {
        //     title: 'IVT (PX)',
        //     dataIndex: 'px_ivt',
        //     width: 150,
        //     key: 'px_ivt',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'IVT Risk (PX)',
        //     dataIndex: 'px_ivtRisk',
        //     width: 150,
        //     key: 'px_ivtRisk',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Viewability (PX)',
        //     dataIndex: 'px_view',
        //     width: 150,
        //     key: 'px_view',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Viewability Risk (PX)',
        //     dataIndex: 'px_viewRisk',
        //     width: 150,
        //     key: 'px_viewRisk',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Brand Safety (PX)',
        //     dataIndex: 'px_bsRisk',
        //     width: 150,
        //     key: 'px_bsRisk',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
        //                     data.length >= 30 ?
        //                         <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
        //                         <div className='text_ellipsis d-block' >{data}</div>
        //                 }
        //             </>
        //         )

        //     },
        // },

        // {
        //     title: 'Domain Age (PX)',
        //     dataIndex: 'px_age',
        //     width: 150,
        //     key: 'px_age',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Privacy Policy (PX)',
        //     dataIndex: 'px_pp',
        //     width: 150,
        //     key: 'px_pp',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data === true ? "yes" : "no"}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Adult Content (PX)',
        //     dataIndex: 'px_adult',
        //     width: 150,
        //     key: 'px_adult',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Alcohol Content (PX)',
        //     dataIndex: 'px_alcohol',
        //     width: 150,
        //     key: 'px_alcohol',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Drug Content (PX)',
        //     dataIndex: 'px_drug',
        //     width: 150,
        //     key: 'px_drug',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },
        // {
        //     title: 'Hate Speech Content (PX)',
        //     dataIndex: 'px_speech',
        //     width: 200,
        //     key: 'px_speech',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },

        // {
        //     title: 'Inventory (PX)',
        //     dataIndex: 'px_invByCo',
        //     width: 160,
        //     key: 'px_invByCo',
        //     render: (data, record) => {
        //         const display = Object.entries(data)?.map(([country, value]) => ({
        //             country: country,
        //             value: value
        //         }));
        //         return (
        //             <>
        //                 {(Object.keys(data).length === 0 && data !== undefined) ? <><div className='text_dark'>-</div></> :
        //                     <div className='anchor_text_link_d2' onClick={() => {
        //                         setIsModalVisibleCountryRequest(true);
        //                         setModalCountryRequest_preview(display)
        //                     }
        //                     } >View</div>
        //                 }
        //             </>
        //         )

        //     },
        // },
        // {
        //     title: 'MFA (PX)',
        //     dataIndex: 'px_mfa',
        //     width: 150,
        //     key: 'px_mfa',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {data}
        //                     </>
        //                 }
        //             </>

        //         )
        //     },
        // },

        // {
        //     title: 'Sub Domains (PX)',
        //     dataIndex: 'px_subs',
        //     width: 160,
        //     key: 'px_subs',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(Array.isArray(data)) ?
        //                     data.length > 0 ?
        //                         <div className='anchor_text_link_d2' onClick={() => {
        //                             setIsModalVisibleCountryRequest(true);
        //                             setModalCountryRequest_preview(data)
        //                             setModalCountryRequest_preview_Type("domains")
        //                         }
        //                         } >View</div> :
        //                         <><div className='text_dark'>-</div></>
        //                     :
        //                     <><div className='text_dark'>-</div></>}

        //             </>
        //         )

        //     },
        // },


        {
            title: 'Inserted Date',
            dataIndex: 'insertedDate',
            width: 120,
            key: 'insertedDate',
            render: (data, record) => {
                return (
                    <>
                        {data}
                    </>
                )

            },
        },
        // {
        //     title: 'Created At',
        //     dataIndex: 'createdAt',
        //     width: 150,
        //     key: 'createdAt',
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
        //                     <div className='text_ellipsis d-block' >{data}</div>
        //                 }
        //             </>
        //         )

        //     },
        // },
        {
            title: 'Updated At',
            dataIndex: 'updated',
            width: 120,
            key: 'updated',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Error',
            dataIndex: 'err',
            width: 70,
            key: 'err',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{JSON.stringify(data)}</div>
                        }
                    </>
                )

            },
        },
        {
            title: 'Error Message',
            dataIndex: 'err_msg',
            width: 250,
            key: 'err_msg',
            render: (data, record) => {
                return (
                    <>
                        {(data === "" || data === "-" || data === undefined || data === null) ? <><div className='text_dark'>-</div></> :
                            data.length >= 30 ?
                                <Tooltip title={data}><div className='text_ellipsis d-block' style={{ cursor: "pointer" }}>{data}</div></Tooltip> :
                                <div className='text_ellipsis d-block' >{data}</div>
                        }
                    </>
                )

            },
        },

    ])

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()


        axios
            .get(configData.SERVER_URL + "adsTxt/filters", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setFilterDropdowns(response.data.result);
            })
            .catch((error) => { });

        getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    useEffect(() => {

        if (Object.keys(filterDropdowns).length > 0) {

            if ('adcodes' in filterDropdowns) {
                setFilterRepeaterValueOptions_adcodes(filterDropdowns.adcodes)
            }
            if ('m_lang' in filterDropdowns) {
                setFilterRepeaterValueOptions_language_meta(filterDropdowns.m_lang)
            }
            if ('gpt_bs' in filterDropdowns) {
                setFilterRepeaterValueOptions_brand_safety(filterDropdowns.gpt_bs)
            }
            if ('tld_co' in filterDropdowns) {
                setFilterRepeaterValueOptions_country_tld(filterDropdowns.tld_co)
            }
            if ('gpt_geo' in filterDropdowns) {
                setFilterRepeaterValueOptions_country_gpt(filterDropdowns.gpt_geo)
            }
            if ('co_req' in filterDropdowns) {
                setFilterRepeaterValueOptions_country_request(filterDropdowns.co_req)
            }

            // if ('px_ivtRisk' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_ivtRisk(filterDropdowns.px_ivtRisk)
            // }
            // if ('px_viewRisk' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_viewRisk(filterDropdowns.px_viewRisk)
            // }
            // if ('px_adult' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_adult(filterDropdowns.px_adult)
            // }
            // if ('px_alcohol' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_alcohol(filterDropdowns.px_alcohol)
            // }
            // if ('px_drug' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_drug(filterDropdowns.px_drug)
            // }
            // if ('px_speech' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_speech(filterDropdowns.px_speech)
            // }
            // if ('px_mfa' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_mfa(filterDropdowns.px_mfa)
            // }
            // if ('px_cat' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_cat(filterDropdowns.px_cat)
            // }
            // if ('px_bsRisk' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_bsRisk(filterDropdowns.px_bsRisk)
            // }
            // if ('px_invByCo' in filterDropdowns) {
            //     setFilterRepeaterValueOptions_px_invByCo(filterDropdowns.px_invByCo)
            // }

            const tempColumns = [...columnsAll];
            const tempColvis = { ...colvis };

            // Utility function for width calculation
            const getWidth = (label) => {
                const length = label?.length || 0;
                if (length > 40) return 250;
                if (length > 35) return 240;
                if (length > 30) return 220;
                if (length > 25) return 200;
                if (length > 22) return 180;
                if (length > 19) return 170;
                if (length > 16) return 160;
                if (length > 13) return 140;
                if (length > 10) return 120;
                return 100;
            };

            if ('adcodes' in filterDropdowns) {

                filterDropdowns.adcodes.forEach((item) => {
                    tempColumns.push({
                        title: item.label.length > 35
                            ? <Tooltip title={item.label}>{item.label.slice(0, 35)}...</Tooltip>
                            : item.label,
                        dataIndex: item.value,
                        key: item.value,
                        width: getWidth(item.label),
                    });

                    // Set default visibility to true if not already defined
                    if (!(item.value in tempColvis)) {
                        tempColvis[item.value] = true;
                    }
                });
            }
            setColumnsAll(tempColumns);
            setColvis(tempColvis);

        }

        // if (Array.isArray(filterDropdowns) && filterDropdowns.length > 5) {

        //     const tempColumns = [...columnsAll];
        //     const tempColvis = { ...colvis };

        //     if ('adcodes' in filterDropdowns[5]) {

        //         filterDropdowns[5]?.adcodes.forEach((item) => {
        //             tempColumns.push({
        //                 title: item.label.length > 15 ? <Tooltip title={item.label}>{item.label.slice(0, 15)}...</Tooltip> : item.label,
        //                 dataIndex: item.value,
        //                 key: item.value,
        //                 width: 150,
        //             });

        //             // Set default visibility to true if not already defined
        //             if (!(item.value in tempColvis)) {
        //                 tempColvis[item.value] = true;
        //             }
        //         });

        //         console.log("Updated columns:", tempColumns);

        //         // Update the state
        //         setColumnsAll(tempColumns);
        //         setColvis(tempColvis);
        //     }
        // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterDropdowns])

    useEffect(() => {

        let tempLength = Object.keys(colvis).length;
        if (tempLength !== colvisLength) {

            setColumnsAll(columnsAll.map((column) =>
                column.key in colvis // Check if the key exists in colvis
                    ? { ...column, hidden: !colvis[column.key] } // Update hidden if the key exists
                    : column // Leave unchanged if the key doesn't exist
            ))
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colvis])



    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 100,
        total: 10,
    });
    const [sortObject, setSortObject] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")


    function addCommasToNumber(num) {
        const isDecimal = num % 1 !== 0;
        let numStr = num.toString();
        let [wholePart, decimalPart] = numStr.split(".");
        wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (isDecimal) {
            numStr = `${wholePart}.${decimalPart}`;
        } else {
            numStr = wholePart;
        }

        return numStr;
    }


    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            const sort = sortObject["name"] === '' ? {} : { [sortObject["name"]]: sortObject["type"] };
            // let dateRangeCall = { start: dateRange.start.format('DD/MM/YYYY'), end: dateRange.end.format('DD/MM/YYYY') }

            let tempArr = { ...filterApplyApiCall }
            tempArr.filterArray = filterApplyApiCall.filterArray.map(({ valueSearch, options, validation_value, ...rest }) => rest);

            axios.post(configData.SERVER_URL + `adsTxt/app-txt-data`, {
                search: search,
                page: page.current,
                limit: page.pageSize,
                sort: sort,
                // filter: filterApplyApiCall
                filter: tempArr
                // checkedPublishers: checkedPublishers,
                // checkedPublishers: filterApplyApiCall.publisher,
                // dateRange: { start: dateRange.start, end: dateRange.end }
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
            })
                .then((response) => {


                    // const data = response.data.data.data; // unused
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.totalEntries

                        setPage(tempPage)
                    }
                    else {
                        let tempPage = { ...page }
                        tempPage.current = 1
                        tempPage.total = 0
                        setPage(tempPage)
                    }

                    setData(response.data.data.data)
                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }


    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);

                setApicall(!apiCall)
            }, 400); // 500ms delay
            // Cleanup function to clear the timeout if query changes
            return () => clearTimeout(delayDebounceFn);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);


    const handleTableChange = (pagination, filters, sorter) => {
        setSortObject({ name: sorter.field, type: sorter.order === "ascend" ? 1 : -1 });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {

        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };


    // ///////////////////date range picker code ////////////////////////

    // const [dateRange, setDateRange] = useState({
    //     start: moment().subtract(29, 'days'),
    //     end: moment(),
    // });

    // const { start, end } = dateRange;

    // const label =
    //     start?.format('DD/MM/YYYY') + ' - ' + end?.format('DD/MM/YYYY');

    // const datepickerRef = useRef(null);


    //-----------------------------------------------------------------------------------------------------------------------------//
    const [taggingShow, setTaggingShow] = useState(false)
    const [cssToggle, setCssToggle] = useState(true)
    const dropdownRef1 = useRef(null);

    useEffect(() => {
        function handleClickOutside1(event) {
            if (
                dropdownRef1.current &&
                !dropdownRef1.current.contains(event.target) &&
                taggingShow
            ) {
                const selectElement = document.getElementById('adcodeSelect2'); // assuming this is the parent of the actual dropdown
                if (!(selectElement?.closest('.ant-select')?.classList?.contains('ant-select-open'))) {

                    const shakeDiv = document.getElementById("shakeDiv");
                    if (!shakeDiv.contains(event.target)) {
                        shakeDiv.classList.add("shake");
                        setTimeout(() => {
                            shakeDiv.classList.remove("shake");
                        }, 500);
                    }
                }
            }

        }
        document.addEventListener("mousedown", handleClickOutside1);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside1);
        };
    });

    const [mediakit, setMediakit] = useState({});
    const [mediakitIsReqiredError, setMediakitIsRequiredError] = useState(false);

    const [markedTag, setMarkedTag] = useState("Blacklist");
    const [markedTagOptions] = useState([{
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingPremiumIcon} alt="" />
                <span>
                    Premium
                </span>

            </div>
        ),
        value: 'Premium',
    },
    {
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingGoodIcon} alt="" />
                <span>
                    Good
                </span>

            </div>
        ),
        value: 'Good',
    },
    {
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingLowIcon} alt="" />
                <span>
                    Low
                </span>

            </div>
        ),
        value: 'Low',
    },
    {
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingBlacklistIcon} alt="" />
                <span>
                    Blacklist
                </span>

            </div>
        ),
        value: 'Blacklist',
    },
    {
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingBlockedIcon} alt="" />
                <span>
                    Blocked
                </span>

            </div>
        ),
        value: 'Blocked',
    },
    {
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingDirectIcon} alt="" />
                <span>
                    Direct
                </span>

            </div>
        ),
        value: 'Direct',
    },
    {
        label: (
            <div className="add_newbtn_design2 d-flex justify-content-start align-items-center gap_8">
                <img src={taggingNoTagIcon} alt="" />
                <span>
                    No Tag
                </span>

            </div>
        ),
        value: 'No Tag',
    },

    ]);

    const [buttonProcessingTagging, setButtonProcessingTagging] = useState(false);


    function resetStatesTagging() {
        setTaggingShow(!taggingShow);
        document.querySelector('.tagging_filter_overlay').classList.toggle('active', !taggingShow);
        setCssToggle(true)
        setMediakit({});
        setMediakitIsRequiredError(false);
        setMarkedTag("Blacklist");
        setButtonProcessingTagging(false)
    }

    function isValidDomain(domain) {
        const domainPattern = /.+[.].+/;
        return domainPattern.test(domain);
    }

    function onChangeMediakit(e) {
        const file = e.target.files[0];

        if (file !== undefined) {

            if (file.size / (1024 * 1024) < 100 && file.type === "text/csv") {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const text = e.target.result;
                    const domains = text.split('\n').filter(domain => domain.trim() !== '');
                    const validDomains = domains.filter(domain => isValidDomain(domain.trim()));
                    const invalidDomains = domains.length - validDomains.length;

                    if (validDomains.length > 1000 || invalidDomains > 0) {
                        const errorMessage = validDomains.length > 1000
                            ? 'The file contains more than 1000 domains.'
                            : 'The file contains invalid domain(s).';
                        notifyfailure(errorMessage);
                    } else {
                        setMediakit({
                            data: file,
                            preview: URL.createObjectURL(file),
                            filename: file.name,
                            size: file.size
                        });
                        setCssToggle(!cssToggle);
                        setMediakitIsRequiredError(false)
                    }
                };

                reader.onerror = () => {
                    notifyfailure('Error reading file.');
                };

                // Start reading the file as text
                reader.readAsText(file);

            } else {
                if (file.size / (1024 * 1024) >= 100) {
                    notifyfailure('File must be less than 100 MB in size');
                } else {
                    notifyfailure('Unsupported file format. Please upload a CSV file');
                }
            }
        }

        const fileInput00 = document.getElementById("file0040");
        if (fileInput00) {
            fileInput00.value = "";
        }
    }

    function onChangeMarkedTag(event) {
        setMarkedTag(event)
    }


    const handleDownload = async () => {


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL +
                    `adsTxt/downloadDomain`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "text/csv;charset=utf-8",
                    });
                    saveAs(blob, "sample.csv");
                })
                .catch((error) => { });
        }
    };

    const handSubmitTagging = async (e) => {
        e.preventDefault();

        if (
            Object.keys(mediakit).length > 0
        ) {
            if (
                mediakitIsReqiredError === false
            ) {

                let formData = new FormData();
                formData.append("tagName", markedTag);
                formData.append('file', mediakit.data);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonProcessingTagging(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `adsTxt/t_domains`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message);
                            resetStatesTagging()
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonProcessingTagging(false);
                        });
                }
            }
        } else {
            if (Object.keys(mediakit).length === 0) {
                setMediakitIsRequiredError(true)
            }

        }
    };



    ////////////////---------------------check adcodes dropdown related code ------------------//////////////////////////////////////////////////////////////////////////

    const [checkAdcodesShow, setCheckAdcodesShow] = useState(false)
    const [cssToggleCheckCodes, setCssToggleCheckCodes] = useState(true)
    const [buttonProcessingCheckAdcodes, setButtonProcessingCheckAdcodes] = useState(false)
    const [checkAdcodesSubmitType, setCheckAdcodesSubmitType] = useState("");
    const dropdownRef2 = useRef(null);

    useEffect(() => {
        function handleClickOutside2(event) {
            if (
                dropdownRef2.current &&
                !dropdownRef2.current.contains(event.target) &&
                checkAdcodesShow
            ) {
                const shakeDiv = document?.getElementById("shakeDiv2");
                if (!shakeDiv.contains(event.target)) {
                    shakeDiv.classList.add("shake");
                    setTimeout(() => {
                        shakeDiv.classList.remove("shake");
                    }, 500);
                }

            }

        }
        document.addEventListener("mousedown", handleClickOutside2);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside2);
        };
    });


    function resetStatesCheckAdcodes() {
        setCheckAdcodesShow(!checkAdcodesShow);
        document.querySelector('.tagging_filter_overlay').classList.toggle('active', !checkAdcodesShow);
        setCssToggleCheckCodes(true)
        setMediakitCheckAdcodes({});
        setMediakitCheckAdcodesIsRequiredError(false);

        setFilterGroups([
            [
                { value: "", condition: "", validation: false },
                { value: "", condition: "", validation: false },
            ]
        ])
        setFilterCheckAdcodesIsRequiredError(false)

        setButtonProcessingCheckAdcodes(false)
        setCheckAdcodesSubmitType("")
    }

    const [mediakitCheckAdcodes, setMediakitCheckAdcodes] = useState({});
    const [mediakitCheckAdcodesIsReqiredError, setMediakitCheckAdcodesIsRequiredError] = useState(false);

    function onChangeMediakitCheckAdcodes(e) {
        const file = e.target.files[0];

        if (file !== undefined) {

            if (file.size / (1024 * 1024) < 100 && file.type === "text/csv") {
                const reader = new FileReader();
                reader.onload = (e) => {
                    // const text = e.target.result;
                    // const domains = text.split('\n').filter(domain => domain.trim() !== '' && !domain.includes(' '));
                    // const validDomains = domains.filter(domain => isValidDomain(domain.trim()));
                    // const invalidDomains = domains.length - validDomains.length;

                    // if (validDomains.length > 10000 || invalidDomains > 0) {
                    //     const errorMessage = validDomains.length > 10000
                    //         ? 'The file contains more than 10,000 domains.'
                    //         : 'The file contains invalid domain(s) or multiple domains in one line..';
                    //     notifyfailure(errorMessage);
                    // }
                    const text = e.target.result;
                    const lines = text.split('\n');

                    const validDomains = [];
                    let invalidDomains = 0;

                    for (const line of lines) {
                        const trimmed = line.trim();
                        const parts = trimmed.split(',');

                        if (
                            trimmed === '' ||                  // skip empty lines
                            parts.length !== 1 ||              // more than one column
                            trimmed.includes(' ') ||           // contains spaces
                            !isValidDomain(trimmed)            // fails domain validation
                        ) {
                            if (trimmed !== '') invalidDomains++; // count non-empty invalid lines
                            continue;
                        }

                        validDomains.push(trimmed);
                    }

                    if (validDomains.length > 10000 || invalidDomains > 0) {
                        const errorMessage = validDomains.length > 10000
                            ? 'The file contains more than 10,000 domains.'
                            : 'The file contains invalid domain(s) or multiple domains in one line.';
                        notifyfailure(errorMessage);
                    }
                    else {
                        setMediakitCheckAdcodes({
                            data: file,
                            preview: URL.createObjectURL(file),
                            filename: file.name,
                            size: file.size
                        });
                        setCssToggleCheckCodes(!cssToggleCheckCodes);
                        setMediakitCheckAdcodesIsRequiredError(false)
                    }
                };

                reader.onerror = () => {
                    notifyfailure('Error reading file.');
                };

                // Start reading the file as text
                reader.readAsText(file);

            } else {
                if (file.size / (1024 * 1024) >= 100) {
                    notifyfailure('File must be less than 100 MB in size');
                } else {
                    notifyfailure('Unsupported file format. Please upload a CSV file');
                }
            }
        }

        const fileInput00 = document.getElementById("file0045");
        if (fileInput00) {
            fileInput00.value = "";
        }
    }

    const handleDownloadCheckAdcodes = async () => {


        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(
                    configData.SERVER_URL +
                    `adsTxt/downloadDomain`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    }
                )
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: "text/csv;charset=utf-8",
                    });
                    saveAs(blob, "sample.csv");
                })
                .catch((error) => { });
        }
    };

    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    function handleDynamicWidthInput(id, value) {
        const input = document.getElementById(id);
        if (!input) return;

        const style = window.getComputedStyle(input);
        const font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
        context.font = font;
        const textWidth = context.measureText(value || input.placeholder || "").width;

        let minWidth
        if (id === "width_adcode_0") {
            minWidth = 18.3 * 10;
        }
        else {
            minWidth = 14.2 * 10;
        }
        // 14.2rem to px (assuming 16px base font)
        const maxWidth = 350; // max width in px
        const padding = 16; // estimated padding left + right

        const totalWidth = Math.min(Math.max(textWidth + padding, minWidth), maxWidth);
        input.style.width = totalWidth + "px";
    }

    const MAX_GROUPS = 5;

    const [filterGroups, setFilterGroups] = useState([
        [
            { value: "", condition: "", validation: false },
            { value: "", condition: "", validation: false },
        ]
    ]);

    const [filterCheckAdcodesIsRequiredError, setFilterCheckAdcodesIsRequiredError] = useState(false);

    // ========== Top-level Group Functions ==========

    function addFilterGroup() {
        if (filterGroups.length >= MAX_GROUPS) {
            // console.warn("Max 5 groups allowed");
            return;
        }

        setFilterGroups([...filterGroups, [
            { value: "", condition: "", validation: false },
            { value: "", condition: "", validation: false }
        ]]);
    }

    function removeFilterGroup(groupIndex) {
        const tempGroups = [...filterGroups];
        tempGroups.splice(groupIndex, 1);
        setFilterGroups(tempGroups);

        setFilterCheckAdcodesIsRequiredError(false)
    }

    // ========== Inner Group Functions ==========

    function handleFilterCheckAdCodesValue(event, id, groupIndex, index) {
        setFilterCheckAdcodesIsRequiredError(false);

        const inputValue = event.target.value.replace(/,/g, '').trim();
        const tempGroups = [...filterGroups];
        const conditionCheck = { ...tempGroups[groupIndex][index] };

        tempGroups[groupIndex][index].value = inputValue;
        tempGroups[groupIndex][index].validation = false;

        if (inputValue === "") {
            tempGroups[groupIndex][index].condition = "";
        } else {
            if ((!isNaN(inputValue) && conditionCheck.value === "")) {
                tempGroups[groupIndex][index].condition = "direct";
            } else if (isNaN(inputValue) &&
                (conditionCheck.condition === "regex" || conditionCheck.condition === "direct")) {
                tempGroups[groupIndex][index].condition = "";
            } else if ((!isNaN(inputValue)) &&
                (conditionCheck.condition === "" || conditionCheck.condition === "case sensitive")) {
                tempGroups[groupIndex][index].condition = "direct";
            }
        }

        setFilterGroups(tempGroups);
        handleDynamicWidthInput(id, inputValue);
    }

    function handleFilterCheckAdCodesCondition(event, type, groupIndex, index) {
        setFilterCheckAdcodesIsRequiredError(false);
        const tempGroups = [...filterGroups];

        if (type === "radio") {
            tempGroups[groupIndex][index].condition = event.target.value;
        }

        if (type === "checkbox") {
            tempGroups[groupIndex][index].condition = event.target.checked ? "case sensitive" : "";
        }

        tempGroups[groupIndex][index].validation = false;
        setFilterGroups(tempGroups);
    }

    function addFilterCheckAdCodes(groupIndex) {
        const tempGroups = [...filterGroups];
        tempGroups[groupIndex].push({
            value: "",
            condition: "",
            validation: false
        });

        setFilterGroups(tempGroups);
    }

    function removeFilterCheckAdCodes(groupIndex, index) {
        const tempGroups = [...filterGroups];
        tempGroups[groupIndex].splice(index, 1);
        setFilterGroups(tempGroups);
    }

    const validateFilterCheckAdcodes = () => {
        let allValuesValid = true;

        setFilterGroups(prevGroups =>
            prevGroups.map(group =>
                group.map(item => {
                    const isValueEmpty = item.value.trim().length === 0;
                    if (isValueEmpty) {
                        allValuesValid = false;
                    }
                    return {
                        ...item,
                        validation: isValueEmpty,
                    };
                })
            )
        );

        if (!allValuesValid) {
            setFilterCheckAdcodesIsRequiredError(true);
        }

        return allValuesValid;
    };


    const handleSubmitCheckAdcodes = (type) => {
        if (
            mediakitCheckAdcodes?.filename !== "" && mediakitCheckAdcodes?.filename !== undefined
        ) {
            if (
                mediakitCheckAdcodesIsReqiredError === false
            ) {

                if (validateFilterCheckAdcodes()) {

                    setCheckAdcodesSubmitType(type)
                    setButtonProcessingCheckAdcodes(true)

                    let formData = new FormData();

                    formData.append(
                        "adcodes",
                        JSON.stringify(
                            filterGroups.map(group =>
                                group.map(({ value, condition }) => ({ value, condition }))
                            )
                        )
                    );
                    formData.append('file', mediakitCheckAdcodes.data);


                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + (type === "submit" ? `adcodes/submit` : `adcodes/uploadUrl`), formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {
                                notifysuccess(response.data.message)
                                // setApicall(!apiCall)
                                // setIsModalVisible(false)
                                resetStatesCheckAdcodes()
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonProcessingCheckAdcodes(false)
                                setCheckAdcodesSubmitType("")

                            });


                    }
                }
            }
        } else {

            if (mediakitCheckAdcodes?.filename === "" || mediakitCheckAdcodes?.filename === undefined) {
                validateFilterCheckAdcodes()
                setMediakitCheckAdcodesIsRequiredError(true);

            }
        }


    };


    //////////////////////////////////////filter  code  and logic ///////////////////////////////////////////////////////////////////////////////////////////////////////
    const [filterRepeaterConnectorOptions] = useState([{ label: "and", value: "and" }, { label: "or", value: "or" }])
    const [filterRepeaterLabelOptions] = useState(
        [
            { "label": "Adcodes", "value": "adcodes" },
            // { "label": "Adult Content ( PX )", "value": "px_adult" },
            // { "label": "Alcohol Content ( PX )", "value": "px_alcohol" },
            { "label": "Brand Safety (GPT)", "value": "gpt_bs" },
            // { "label": "Brand Safety (PX)", "value": "px_bsRisk" },
            { "label": "Categories (GPT)", "value": "gpt_cat" },
            // { "label": "Categories ( PX )", "value": "px_cat" },
            { "label": "Country (GPT)", "value": "gpt_geo" },
            { "label": "Country (TLD)", "value": "tld_co" },
            { "label": "Country Request", "value": "co_req" },
            // { "label": "Domain Age ( PX )", "value": "px_age" },
            // { "label": "Drug Content ( PX )", "value": "px_drug" },
            // { "label": "Hate Speech Content ( PX )", "value": "px_speech" },
            // { "label": "Inventory ( PX )", "value": "px_invByCo" },
            // { "label": "IVT ( PX )", "value": "px_ivt" },
            // { "label": "IVT Risk ( PX )", "value": "px_ivtRisk" },
            { "label": "Keywords (Meta)", "value": "m_words" },
            { "label": "Language (Meta)", "value": "m_lang" },
            // { "label": "MFA ( PX )", "value": "px_mfa" },
            // { "label": "Privacy Policy ( PX )", "value": "px_pp" },
            { "label": "Publisher Request", "value": "pub_req" },
            // { "label": "Viewability ( PX )", "value": "px_view" },
            // { "label": "Viewability Risk ( PX )", "value": "px_viewRisk" },
            { "label": "Tags", "value": "tagName" },
        ])

    const [filterRepeaterValueOptions_adcodes, setFilterRepeaterValueOptions_adcodes] = useState([])
    const [filterRepeaterValueOptions_language_meta, setFilterRepeaterValueOptions_language_meta] = useState([])
    const [filterRepeaterValueOptions_country_tld, setFilterRepeaterValueOptions_country_tld] = useState([])
    const [filterRepeaterValueOptions_country_gpt, setFilterRepeaterValueOptions_country_gpt] = useState([])
    const [filterRepeaterValueOptions_brand_safety, setFilterRepeaterValueOptions_brand_safety] = useState([])
    const [filterRepeaterValueOptions_country_request, setFilterRepeaterValueOptions_country_request] = useState([])
    const [filterRepeaterValueOptions_px_ivtRisk] = useState([])
    const [filterRepeaterValueOptions_px_viewRisk] = useState([])
    const [filterRepeaterValueOptions_px_adult] = useState([])
    const [filterRepeaterValueOptions_px_alcohol] = useState([])
    const [filterRepeaterValueOptions_px_drug] = useState([])
    const [filterRepeaterValueOptions_px_speech] = useState([])
    const [filterRepeaterValueOptions_px_mfa] = useState([])
    const [filterRepeaterValueOptions_px_cat] = useState([])
    const [filterRepeaterValueOptions_px_bsRisk] = useState([])
    const [filterRepeaterValueOptions_px_invByCo] = useState([])
    const [filterRepeaterValueOptions_tagName] = useState([{ label: "Premium", value: "Premium" }, { label: "Good", value: "Good" }, { label: "Low", value: "Low" }, { label: "Blacklist", value: "Blacklist" }, { label: "Blocked", value: "Blocked" }, { label: "Direct", value: "Direct" }])

    const [filterRepeaterConditionOptions_publisher_request] = useState([{ label: "(>=) greater than equal to", value: ">=" }, { label: "(<=) less than equal to", value: "<=" }, { label: "(=) equal to", value: "=" }])
    const [filterRepeaterConditionOptions_tagName] = useState([{ label: "Includes", value: "Includes" }, { label: "Excludes", value: "Excludes" }])
    const [filterRepeaterConditionOptions_country_request] = useState([{ label: <div className="hidespan_d2"> &gt;= <span>greater than equal to</span></div>, value: ">=" }, { label: <div className="hidespan_d2">&lt;= <span>less than equal to</span></div>, value: "<=" }, { label: <div className="hidespan_d2">= <span>equal to</span></div>, value: "=" }])

    const [searchFilter_category, setSearchFilter_category] = useState([{ search: "", index: null }])
    const [LoaderFilter_category, setLoaderFilter_category] = useState({ loading: false, index: null })

    const handleSearchFilter_category = (event, index) => {
        const searchValue = event;

        let tempSearch = [...searchFilter_category]
        tempSearch[index].search = searchValue
        setSearchFilter_category(tempSearch)

        let tempFilterRepeator = [...filterRepeater]
        tempFilterRepeator[index].searchValue = searchValue
        setFilterRepeater(tempFilterRepeator)

        if (searchValue.length > 2 || searchValue.length === 0) {
            setLoaderFilter_category((prev) => ({
                ...prev,
                loading: true, index: index
            }));
        }

    }

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempFilterRepeator = [...filterRepeater]
                if (LoaderFilter_category.loading) {
                    axios
                        .post(configData.SERVER_URL + "adsTxt/catData?search=" + searchFilter_category[LoaderFilter_category.index].search, { selected: filterRepeater[LoaderFilter_category.index].value }, {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })
                        .then((response) => {

                            tempFilterRepeator[LoaderFilter_category.index].options = [...response.data.selected, ...response.data.options].filter((value, index, self) =>
                                index === self.findIndex((t) => (
                                    t.label === value.label
                                ))
                            );
                            setFilterRepeater(tempFilterRepeator)
                            setLoaderFilter_category((prev) => ({
                                ...prev,
                                loading: false,
                            }));

                        })
                        .catch((error) => {

                            setLoaderFilter_category((prev) => ({
                                ...prev,
                                loading: false,
                            }));

                        });
                }

            }, 500); // 500ms delay
            return () => clearTimeout(delayDebounceFn);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LoaderFilter_category]);


    //---------------------------------------------------------------------------------------------------------------------------//

    const [filterShow, setFilterShow] = useState(false)
    const [filterRepeaterConnectorValue, setFilterRepeaterConnectorValue] = useState("and")
    const [filterRepeater, setFilterRepeater] = useState([]);
    const [filterApplyApiCall, setFilterApplyApiCall] = useState({ connector: "", filterArray: [] });


    const dropdownRef = useRef(null);
    const filterShowRef = useRef(filterShow);
    useEffect(() => {
        filterShowRef.current = filterShow;
    }, [filterShow]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
                &&
                filterShowRef
            ) {
                const allSelectElements = document.querySelectorAll('#adcodeSelect');
                const allDropdownsClosed = Array.from(allSelectElements).every((selectElement) => {
                    return !selectElement.closest('.ant-select')?.classList?.contains('ant-select-open');
                });

                if (allDropdownsClosed) {

                    setFilterRepeater(filterApplyApiCall?.filterArray)
                    setFilterRepeaterConnectorValue(filterApplyApiCall.connector === "" ? "and" : filterApplyApiCall.connector)
                    setFilterShow(false);
                }
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    });


    const handleAddFilterRepeater = (data) => {
        if (data === "m_words") {
            setFilterRepeater([
                ...filterRepeater,
                {
                    label: data,
                    value: "",
                    condition: "",
                    other: "",
                    valueSearch: "",
                    options: [],
                    validation_value: false,

                },
            ]);
        }
        else if (data === "px_pp") {
            setFilterRepeater([
                ...filterRepeater,
                {
                    label: data,
                    value: "yes",
                    condition: "",
                    other: "",
                    valueSearch: "",
                    options: [],
                    validation_value: false,

                },
            ]);
        }
        else if (data === "pub_req" || data === "co_req" || data === "px_view" || data === "px_age" || data === "px_ivt" || data === "px_invByCo") {
            setFilterRepeater([
                ...filterRepeater,
                {
                    label: data,
                    value: "",
                    condition: ">=",
                    other: "",
                    valueSearch: "",
                    options: [],
                    validation_value: false,

                },
            ]);
        }
        else if (data === "tagName") {
            setFilterRepeater([
                ...filterRepeater,
                {
                    label: data,
                    value: [],
                    condition: "Includes",
                    other: "",
                    valueSearch: "",
                    options: [],
                    validation_value: false,

                },
            ]);
        }
        else {
            setFilterRepeater([
                ...filterRepeater,
                {
                    label: data,
                    value: [],
                    condition: "",
                    other: "",
                    valueSearch: "",
                    options: [],
                    validation_value: false,

                },
            ]);
        }

        setSearchFilter_category([...searchFilter_category, { search: "" }])

    };

    const handleRemoveFeedListRepeater = (index) => {
        let tempFilter = [...filterRepeater];
        tempFilter.splice(index, 1);
        setFilterRepeater(tempFilter);

        let tempCategory = [...searchFilter_category];
        tempCategory.splice(index, 1);
        setSearchFilter_category(tempCategory);

    };

    const handleChangeFilterLabel = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["label"] = event;
        if (event === "m_words" || event === "pub_req" || event === "co_req" || event === "px_view" || event === "px_age" || event === "px_ivt" || event === "px_invByCo") {
            tempFilter[index]["value"] = "";
        }
        else if (event === "px_pp") {
            tempFilter[index]["value"] = "yes";
        }
        else {
            tempFilter[index]["value"] = [];
        }

        if (event === "pub_req" || event === "co_req" || event === "px_view" || event === "px_age" || event === "px_ivt" || event === "px_invByCo") {
            tempFilter[index]["condition"] = ">=";
        }
        else if (event === "tagName") {
            tempFilter[index]["condition"] = "Includes";
        }
        else {
            tempFilter[index]["condition"] = "";
        }

        tempFilter[index]["other"] = "";
        tempFilter[index]["valueSearch"] = "";
        tempFilter[index]["options"] = [];
        tempFilter[index]["validation_value"] = false;
        setFilterRepeater(tempFilter);
    };

    const handleChangeValueSearch = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["valueSearch"] = event.target.value.trim();
        setFilterRepeater(tempFilter);
    };

    const handleChangeFilterCondition = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["condition"] = event
        setFilterRepeater(tempFilter);
    };

    const handleChangeFilterOther = (event, index) => {
        const tempFilter = [...filterRepeater];
        tempFilter[index]["other"] = event
        tempFilter[index]["validation_value"] = false
        setFilterRepeater(tempFilter);
    };

    const handleChangeFilterValue = (event, index, type) => {
        const tempFilter = [...filterRepeater];



        if (type === "m_words") {
            tempFilter[index].value = event.target.value
            tempFilter[index].validation_value = false
        }
        else if (type === "px_pp") {
            tempFilter[index].value = event.target.value
        }
        else if (type === "pub_req" || type === "co_req" || type === "px_view" || type === "px_age" || type === "px_ivt" || type === "px_invByCo") {
            if (/^\d*\.?\d*$/.test(event.target.value)) {
                tempFilter[index].value = event.target.value
                tempFilter[index].validation_value = false
            }
        }
        else {
            let newValue = [];
            if (tempFilter[index].value.includes(event)) {
                newValue = tempFilter[index].value.filter((item) => item !== event);
            } else {
                newValue = [...tempFilter[index].value, event];
            }

            if (newValue.length === 0) {
                tempFilter[index].validation_value = true
            }
            else {
                tempFilter[index].validation_value = false
            }
            tempFilter[index].value = newValue

        }

        setFilterRepeater(tempFilter);



    };


    const validateFilterValue = () => {
        let allValuesValid = true;
        setFilterRepeater(prevFilterRepeater =>
            prevFilterRepeater.map(item => {
                let isValueEmpty;
                if (item.label === "m_words" || item.label === "pub_req" || item.label === "px_view" || item.label === "px_age" || item.label === "px_ivt") {
                    isValueEmpty = item.value.trim().length === 0;
                }
                else if (item.label === "co_req" || item.label === "px_invByCo") {
                    isValueEmpty = item.value.trim().length === 0 || item.other.length === 0;
                }
                else {
                    isValueEmpty = item.value.length === 0;
                }
                if (isValueEmpty) {
                    allValuesValid = false;
                }
                return {
                    ...item,
                    validation_value: isValueEmpty,
                };
            })
        );
        return allValuesValid;
    };


    const handleApplyFilterRepeater = () => {

        if (validateFilterValue()) {
            let tempArr = { ...filterApplyApiCall }
            tempArr.connector = filterRepeaterConnectorValue
            tempArr.filterArray = filterRepeater
            setFilterApplyApiCall(tempArr)
            setFilterShow(false)
        }

    };

    const handleResetFilterRepeater = () => {
        setFilterApplyApiCall({
            connector: "",
            filterArray: [],
        })
        setFilterRepeater([])
        setFilterRepeaterConnectorValue("and")
        setFilterShow(false)

    };

    useEffect(() => {
        if (!initialLoad) {
            let tempPage = page
            tempPage.current = 1
            setPage(tempPage);
            setApicall(!apiCall)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterApplyApiCall])



    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>
                        <div className='float_text_div'>
                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>
                            </div>
                        </div>
                    </div>
                    :

                    (filterApplyApiCall.filterArray.length > 0) && loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        (filterApplyApiCall.filterArray.length > 0) && !loading ?
                            <div className='no_data_screen'>
                                <div className='text-center'>
                                    <img src={errorData} className='' alt="" />
                                    <div className='float_text_div'>

                                    </div>
                                </div>
                            </div>
                            :

                            loading ?
                                <div className='no_data_screen'>
                                    <div className='text-center'>
                                        <div className='float_text_div'>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className='no_data_screen' >
                                    <div className='text-center'>
                                        <img src={noData} className='' alt="" />
                                        <div className='float_text_div'>
                                        </div>
                                    </div>
                                </div>
            }
            </>

    };


    const scrollableDivRef = useRef(null);
    const [prevRepeaterCount, setPrevRepeaterCount] = useState(filterRepeater.length);

    const [openSelectState, setOpenSelectState] = useState({});


    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    // Handle scroll to close all Select dropdowns
    useEffect(() => {
        const handleScroll = () => {
            if (Object.values(openSelectState).some((isOpen) => isOpen)) {
                setOpenSelectState({}); // Close all open dropdowns
            }
        };

        const debouncedHandleScroll = debounce(handleScroll, 50); // Debounce for smoothness
        // const scrollableDiv = scrollableDivRef.current;

        const currentDiv = scrollableDivRef.current;
        if (currentDiv) {
            currentDiv.addEventListener('scroll', debouncedHandleScroll);
        }


        return () => {
            if (currentDiv) {
                currentDiv.removeEventListener('scroll', debouncedHandleScroll);
            }
        };

    }, [openSelectState]);


    useEffect(() => {
        if (filterRepeater.length > prevRepeaterCount) {
            // Scroll only when a new form is added
            if (scrollableDivRef.current) {
                scrollableDivRef.current.scrollTop = scrollableDivRef.current.scrollHeight;
            }
            setPrevRepeaterCount(filterRepeater.length); // Update the count
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterRepeater]);

    // Function to toggle open state for a specific Select
    const toggleSelectOpen = (key, open) => {
        setOpenSelectState((prevState) => {
            if (prevState[key] === open) return prevState; // Avoid unnecessary updates
            return { ...prevState, [key]: open };
        });
    };


    const refs = {};
    function getRef(key) {
        if (!refs[key]) {
            refs[key] = React.createRef();
        }
        return refs[key];
    }

    useEffect(() => {
        Object.keys(openSelectState).forEach((key) => {
            if (openSelectState[key]) {
                const ref = refs[key];
                setTimeout(() => {
                    ref?.current?.focus();
                }, 0);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openSelectState]);

    ///////////////////////////////////////////////publisher domain listing code ///////////////////////////
    // Modal related code .............................................................................................................................
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const closeModal = () => {
        setIsModalVisible(false);
        resetModalData()
    };


    useEffect(() => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + "zone/pubMinifiedList", {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    setPublisherOptions(response.data.data);
                })
                .catch((error) => { });
        }
    }, []);


    function resetModalData() {
        setPublisher("")
        setPublisherIsRequiredError(false)
        setFile({
            data: "",
            filename: "",
            type: "",
            size: ""
        })
        setFileIsRequiredError(false)
        setButtonProcessing(false)
    }


    const [buttonProcessing, setButtonProcessing] = useState(false)
    const [publisher, setPublisher] = useState("")
    const [publisherOptions, setPublisherOptions] = useState([])
    const [publisherIsRequiredError, setPublisherIsRequiredError] = useState(false)

    function onChangePublisher(event) {
        setPublisher(event)
        setPublisherIsRequiredError(false)
    }

    function isValidDomainPublisher(domain) {
        // const domainPattern = /^(?!https?:\/\/)(?!www\.)[^.\s]+\.[^.\s]+$/;
        const domainPattern = /^(?!https?:\/\/)(?!www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return domainPattern.test(domain);
    }

    const [file, setFile] = useState({
        data: "",
        filename: "",
        type: "",
        size: ""
    });
    const [fileIsRequiredError, setFileIsRequiredError] = useState(false);

    function onChangeFile(e) {

        const file = e.target.files[0];

        if (file !== undefined) {

            if (file.size / (1024 * 1024) < 100 && file.type === "text/csv") {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const text = e.target.result;
                    const domains = text.split('\n').filter(domain => domain.trim() !== '');
                    const validDomains = domains.filter(domain => isValidDomainPublisher(domain.trim()));
                    const invalidDomains = domains.length - validDomains.length;

                    if (validDomains.length > 1000 || invalidDomains > 0) {
                        const errorMessage = validDomains.length > 1000
                            ? 'The file contains more than 1000 domains.'
                            : 'The file contains invalid domain(s) or format.';
                        notifyfailure(errorMessage);
                    } else {
                        setFile({
                            data: file,
                            filename: file.name,
                            type: file.type,
                            size: file.size / (1024 * 1024)
                        })

                        setFileIsRequiredError(false)
                    }
                };

                reader.onerror = () => {
                    notifyfailure('Error reading file.');
                };

                // Start reading the file as text
                reader.readAsText(file);

            } else {
                if (file.size / (1024 * 1024) >= 100) {
                    notifyfailure('File must be less than 100 MB in size');
                } else {
                    notifyfailure('Unsupported file format. Please upload a CSV file');
                }
            }
        }

        const fileInput00 = document.getElementById("filepublisherDomain01");
        if (fileInput00) {
            fileInput00.value = "";
        }
    }


    const handleSubmitModal = async (e) => {
        e.preventDefault();

        if (
            publisher !== "" &&
            file.filename !== ""
        ) {
            if (
                publisherIsRequiredError === false &&
                fileIsRequiredError === false
            ) {


                let formData = new FormData();


                formData.append("publisher", publisher);
                formData.append('file', file.data);

                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    setButtonProcessing(true);
                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .post(configData.SERVER_URL + `adsTxt/pubDomainUpload`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                "x-access-token": token,
                            }
                        }
                        )
                        .then((response) => {
                            notifysuccess(response.data.message)
                            // setApicall(!apiCall)
                            setIsModalVisible(false)
                            resetModalData()

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonProcessing(false)
                        });


                }
            }
        } else {
            if (publisher.trim() === "") {
                setPublisherIsRequiredError(true);
            }
            if (file.filename === "") {
                setFileIsRequiredError(true);
            }
        }
    };

    /////////////////////////////////////////////Media planner Exort code  starts ///////////////////////////////////////////////////////////

    const [exportShow, setExportShow] = useState(false)
    const [exportMediaPlannerLoading, setExportMediaPlannerLoading] = useState(false)

    function filterMergedArray(arr1, arr2, obj) {
        // Merge the arrays while keeping unique 'value' keys
        const mergedMap = new Map();

        [...arr1, ...arr2].forEach(item => mergedMap.set(item.value, item.label));

        // Filter only those objects where obj[value] is true
        return Array.from(mergedMap)
            .filter(([value]) => obj[value]) // Keep only values that are true in obj
            .map(([value, label]) => ({ label, value }));
    }

    const dropdownExportRef = useRef(null);
    useEffect(() => {
        function handleClickOutside1(event) {
            if (
                dropdownExportRef.current &&
                !dropdownExportRef.current.contains(event.target)
            ) {
                setExportShow(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside1);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside1);
        };
    });

    function hasXapadsInAdcodes(data) {
        return data?.some(obj =>
            obj.label === "adcodes" &&
            Array.isArray(obj.value) &&
            (obj.value.includes("xapads_dir") || obj.value.includes("xapads_res"))
        );
    }



    const exportMediaPlanner = () => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let tempArr = { ...filterApplyApiCall }
            tempArr.filterArray = filterApplyApiCall.filterArray.map(({ valueSearch, options, validation_value, ...rest }) => rest);

            // const extraValues = ["url", "m_lang", "tld_co"];

            // const tempColvisExport = [
            //     ...Object.entries(colvis)
            //         .filter(([_, value]) => value)
            //         .map(([key]) => key),
            //     ...extraValues,
            // ];

            const tempColvisExport = filterMergedArray(filterRepeaterValueOptions_colvis, filterRepeaterValueOptions_adcodes, colvis)

            tempColvisExport.unshift({ label: "Tags", value: "tags" })
            tempColvisExport.unshift({ label: "URL", value: "url" })

            setExportMediaPlannerLoading(true)
            axios
                .post(configData.SERVER_URL + "adsTxt/downloadCSV", {
                    email: jwtDecode(token).email,
                    count: page.total,
                    search: search,
                    filter: tempArr,
                    columnFilter: tempColvisExport
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    if (response.data.message !== undefined) {
                        notifysuccess(response.data.message)
                    }
                    else {
                        const blob = new Blob([response.data], {
                            type: "text/plain;charset=utf-8",
                        });
                        saveAs(blob, "Domains_" + new Date().getTime() + ".csv");
                        // notifysuccess("File downloaded successfully")
                    }

                    setExportMediaPlannerLoading(false)
                })
                .catch((error) => {
                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                        }
                    } else {
                        notifycatch()
                    }
                    setExportMediaPlannerLoading(false)
                });

        }
    };

    const [childExportType, setChildExportType] = useState("");
    const [sortedInfo, setSortedInfo] = useState({});
    const handleTableChangeChild = (pagination, filters, sorter) => {
        setSortedInfo(sorter); // Update sorting state
    };
    const [modalChildExportShow, setModalChildExportShow] = useState(false);
    const [searchChildMapping, setSearchChildMapping] = useState("");
    const [loadingChildMapping, setLoadingChildMapping] = useState(false);
    const [childMappingData, setChildMappingData] = useState([]);
    const [childMappingButtonProcessing, setChildMappingButtonProcessing] = useState(false);
    const childMappingColumns = [
        {
            title: (
                <Checkbox
                    className='table_checkbox_d2'
                    indeterminate={childMappingData?.some(item => item.check) && !childMappingData.every(item => item.check)}
                    checked={childMappingData?.every(item => item.check)}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        let tempData = childMappingData?.map(obj => ({
                            ...obj,
                            check: checked,
                        }));
                        setChildMappingData(tempData);
                    }}
                />
            ),
            dataIndex: 'check',
            key: 'check',
            width: 50,
            render: (text, record) => (
                <Checkbox
                    className='table_checkbox_d2'
                    checked={text}
                    // checked={record.check}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        let tempData = childMappingData?.map(obj =>
                            obj.id === record.id ? { ...obj, check: checked } : obj
                        );
                        setChildMappingData(tempData);
                    }}
                />
            ),
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 300,
            // sorter: true,
            // sorter: (a, b) => a.id - b.id,
            // sortDirections: ['ascend', 'descend', 'ascend'],

        },
        {
            title: 'Count',
            dataIndex: 'count',
            key: 'count',
            width: 300,
            // sorter: true, // duplicate key - overridden below
            sorter: (a, b) => a.count - b.count,
            sortDirections: ['descend', 'ascend', 'descend'],
            sortOrder: sortedInfo.columnKey === 'count' ? sortedInfo.order : undefined,
        },

    ]

    function handleModalChildExportModalClose() {
        setModalChildExportShow(false)
        setSearchChildMapping("")
        setLoadingChildMapping(false)
        setChildMappingData([])
        setChildMappingButtonProcessing(false)
        setChildExportType("")
    }

    function handleSearchChildMapping(event) {
        setSearchChildMapping(event.target.value)
    }


    function handleExportWithChildModalOpen() {

        setExportShow(false);
        setSortedInfo({
            "column": {
                "title": "Count",
                "dataIndex": "count",
                "key": "count",
                "width": 300,
                "sortDirections": [
                    "descend",
                    "ascend",
                    "descend"
                ],
                "sortOrder": "descend"
            },
            "order": "ascend",
            "field": "count",
            "columnKey": "count"
        });
        setLoadingChildMapping(true)

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let tempArr = { ...filterApplyApiCall }
            tempArr.filterArray = filterApplyApiCall.filterArray.map(({ valueSearch, options, validation_value, ...rest }) => rest);
            axios
                .post(configData.SERVER_URL + "adsTxt/childPubList", {
                    email: jwtDecode(token).email,
                    filter: tempArr,
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {

                    if (response.data.data.length > 0) {
                        let tempData = response.data.data?.map(obj => ({ ...obj, check: false }))
                        setChildMappingData(tempData);
                    }
                    setLoadingChildMapping(false)
                    // setModalChildExportShow(true);
                    // setChildMappingData([{ id: "123", count: 1, check: false }, { id: "1234", count: 1, check: false }])
                })
                .catch((error) => {
                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                        }
                    } else {
                        notifycatch()
                    }
                    setLoadingChildMapping(false)
                    // setModalChildExportShow(true);
                });
        }

        setModalChildExportShow(true);



    }


    const exportMediaPlannerWithChild = (exportType) => {
        setChildMappingButtonProcessing(true)
        setChildExportType(exportType)

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            let tempArr = { ...filterApplyApiCall }
            tempArr.filterArray = filterApplyApiCall.filterArray.map(({ valueSearch, options, validation_value, ...rest }) => rest);

            const tempColvisExport = filterMergedArray(filterRepeaterValueOptions_colvis, filterRepeaterValueOptions_adcodes, colvis)

            tempColvisExport.unshift({ label: "Tags", value: "tags" })
            tempColvisExport.unshift({ label: "URL", value: "url" })

            axios
                .post(configData.SERVER_URL + "adsTxt/domains", {
                    email: jwtDecode(token).email,
                    filter: tempArr,
                    ids: childMappingData.filter(item => item.check).map(item => item.id),
                    exportType: exportType
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {
                    if (response.data.message) {
                        notifysuccess(response.data.message)
                    }
                    handleModalChildExportModalClose()
                })
                .catch((error) => {
                    if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                        }
                    } else {
                        notifycatch()
                    }
                    setChildMappingButtonProcessing(false)
                    handleModalChildExportModalClose()
                });

        }
    };

    const localeChildMapping = {
        emptyText:
            <>{
                loadingChildMapping ?
                    <div className='no_data_screen'
                        style={{ height: "40vh" }}
                    >
                        <div className='text-center'>
                            <img src={FullLoader} width={30} height={30} alt="USP" className="" />
                        </div>
                    </div>
                    :
                    searchChildMapping.length > 0 ?
                        <div className='no_data_screen'
                            style={{ height: "40vh" }}
                        >
                            <div className='text-center'
                            >
                                <img src={errorData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen'
                            style={{ height: "40vh" }}
                        >
                            <div className='text-center'
                            >
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };

    /////////////////////////////////////////////Media planner Exort code  ends ///////////////////////////////////////////////////////////

    return (
        <>


            <div className="container_box--wrapper pt_header tagging_filter_related tagging_filter_overlay">
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Domains
                    </h1>

                    <div className="btn_group">
                        {!initialLoad &&
                            <>
                                <button className='btn btn_primary w_fit_content md' onClick={showModal}>
                                    <span><img src={uploadCloudIcon} alt='Add' /> Add Domains</span>
                                </button>
                            </>
                        }
                    </div>

                </div>


                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="form_content_block--group w-auto">
                                    {!initialLoad &&
                                        <div className="tooltip_svg_icon_d2 position-relative">
                                            <Input
                                                type='text'
                                                className='form_control basic md search_input w_table_search'
                                                placeholder="Search"
                                                value={search}
                                                onChange={(e) => {

                                                    if (e.target.value.trim().length === 0) {
                                                        setLoading(true)
                                                    }

                                                    setSearch(e.target.value)
                                                }}
                                            />
                                            <Tooltip title="Search is limited to URL, Country (GPT), Language (Meta), Brand Safety, Categories (GPT), and Country (TLD)."
                                                placement="right"
                                                overlayInnerStyle={{
                                                    width: "500px"
                                                }}
                                            >
                                                <img src={infoIcon} alt="" />
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                                <div className="custom_filter_design_d2 justify_content_end --new_layout_design_btn">
                                    {!initialLoad &&
                                        <>

                                            {/* <div className='date_range_picker_d2'
                        >
                            <DateRangePicker
                                ref={datepickerRef}
                                startDate={dateRange.start}
                                endDate={dateRange.end}

                                initialSettings={{
                                    alwaysShowCalendars: true,
                                    startDate: dateRange.start,
                                    endDate: dateRange.end,
                                    locale: {
                                        format: "DD/MM/YYYY",
                                    },
                                    maxDate: new Date(),
                                    ranges: {
                                        Today: [moment().toDate(), moment().toDate()],
                                        Yesterday: [
                                            moment().subtract(1, 'days').toDate(),
                                            moment().subtract(1, 'days').toDate(),
                                        ],
                                        'Last 7 Days': [
                                            moment().subtract(6, 'days').toDate(),
                                            moment().toDate(),
                                        ],
                                        'Last 30 Days': [
                                            moment().subtract(29, 'days').toDate(),
                                            moment().toDate(),
                                        ],
                                        'This Month': [
                                            moment().startOf('month').toDate(),
                                            moment().endOf('month').toDate(),
                                        ],
                                        'Last Month': [
                                            moment().subtract(1, 'month').startOf('month').toDate(),
                                            moment().subtract(1, 'month').endOf('month').toDate(),
                                        ],
                                    },
                                }}

                                onCallback={(start, end, label) => {
                                    setDateRange({ start: start, end: end });
                                    setApicall(!apiCall)

                                }
                                }


                            >
                                <div id="reportrange">
                                    <img src={RangeCalendar} alt="" />
                                    <span>{label}</span> <i className="fa fa-caret-down"></i>
                                </div>
                            </DateRangePicker>
                        </div> */}


                                            <div className="custom_media_filter_d2 --remove_overflow_css mediaPlanner_filter">

                                                <Dropdown className=""
                                                    ref={dropdownRef}
                                                    show={filterShow} onToggle={() => { setFilterShow(!filterShow) }}
                                                    autoClose={false}>
                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                        <Dropdown.Toggle id="dropdown-autoclose-false px-2">
                                                            <Button className="" icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <path d="M12.5611 2H1.44995L5.8944 7.25556V10.8889L8.11662 12V7.25556L12.5611 2Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }>
                                                                Filter

                                                                {filterApplyApiCall?.filterArray?.length > 0 &&
                                                                    <div className="selected_filter_tag_d2">
                                                                        <div>{filterApplyApiCall?.filterArray?.length}</div>
                                                                    </div>
                                                                }
                                                            </Button>
                                                        </Dropdown.Toggle>
                                                        {filterApplyApiCall?.filterArray?.length > 0 &&
                                                            <div className="clear_filter_icon_d2" style={{ right: '1.7rem', top: '0.8rem' }}>
                                                                <button type="button"> <img src={HoverCloseIcon} alt=""
                                                                    onClick={() => {
                                                                        setFilterApplyApiCall({
                                                                            connector: "",
                                                                            filterArray: [],
                                                                        })
                                                                        setFilterRepeater([])
                                                                        setFilterRepeaterConnectorValue("and")
                                                                        setFilterShow(false)
                                                                    }} />
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>

                                                    <Dropdown.Menu>
                                                        <div className="filter_inner_heading_d2 ">
                                                            <div className="filter_scrollable_div_d2" ref={scrollableDivRef}>
                                                                {filterRepeater.map((x, i) => {
                                                                    return (
                                                                        <Row gutter={8} className='formHtml align-items-start' key={i}>
                                                                            <Col className="or_and_select_d2">

                                                                                {i === 0 ?
                                                                                    <>
                                                                                        <span className="is_text">Where</span>
                                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">


                                                                                        </div>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                                            <Select
                                                                                                id="adcodeSelect"
                                                                                                showSearch={false}
                                                                                                placeholder=""
                                                                                                // open={true}
                                                                                                popupClassName="or_and_d2"
                                                                                                optionFilterProp="label"
                                                                                                className='form_select basic no_search'
                                                                                                options={filterRepeaterConnectorOptions}
                                                                                                open={!!openSelectState[`where-${i}`]}
                                                                                                onDropdownVisibleChange={(open) => toggleSelectOpen(`where-${i}`, open)}
                                                                                                value={filterRepeaterConnectorValue}
                                                                                                onChange={(event) => { setFilterRepeaterConnectorValue(event) }}
                                                                                            />

                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </Col>

                                                                            <Col span={6}>
                                                                                <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">

                                                                                    <Select
                                                                                        id="adcodeSelect"
                                                                                        showSearch={true}
                                                                                        placeholder=""
                                                                                        optionFilterProp="label"
                                                                                        className='form_select basic'
                                                                                        open={!!openSelectState[`property-${i}`]}
                                                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`property-${i}`, open)}
                                                                                        options={filterRepeaterLabelOptions}
                                                                                        value={x.label}
                                                                                        onChange={(event) => {
                                                                                            handleChangeFilterLabel(event, i)

                                                                                        }}
                                                                                    />

                                                                                </div>
                                                                            </Col>

                                                                            <Col className="text-center px-1">
                                                                                <span className="is_text"> {(x.label === "co_req" || x.label === "px_invByCo" || x.label === "tagName") ? <></> : <>is</>}</span>
                                                                            </Col>


                                                                            <Col className="flex-grow-1 checkbox_value_select_d2 multi_select_tag_d2">
                                                                                <div className="form_content_block--group mb_0">
                                                                                    <div className='d-flex '>
                                                                                        <div className="w-100">

                                                                                            {x.label === "tagName" &&
                                                                                                <div className="w-100 d-flex justify-content-between  gap_8">
                                                                                                    <div className="publisher_select_rightleft_spacing_d2">
                                                                                                        <Select
                                                                                                            id="adcodeSelect"
                                                                                                            showSearch={false}
                                                                                                            placeholder=""
                                                                                                            optionFilterProp="label"
                                                                                                            open={!!openSelectState[`propertysix-${i}`]}
                                                                                                            onDropdownVisibleChange={(open) => toggleSelectOpen(`propertysix-${i}`, open)}
                                                                                                            className='form_select basic width_164 no_search'
                                                                                                            options={filterRepeaterConditionOptions_tagName}
                                                                                                            value={x.condition}
                                                                                                            onChange={(event) => { handleChangeFilterCondition(event, i) }}
                                                                                                        />
                                                                                                    </div>

                                                                                                    <Select
                                                                                                        id="adcodeSelect"
                                                                                                        value={x.value}
                                                                                                        popupClassName="diff_select_d2 --value_with_para_text"
                                                                                                        // open={true}
                                                                                                        showSearch={false}
                                                                                                        placeholder='- Select -'
                                                                                                        className={x.validation_value ? 'form_select basic error' : 'form_select basic'}
                                                                                                        mode='multiple'
                                                                                                        open={!!openSelectState[`propertyseven-${i}`]}
                                                                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyseven-${i}`, open)}
                                                                                                        maxTagCount='responsive'
                                                                                                        dropdownRender={menu => (
                                                                                                            <>
                                                                                                                {(
                                                                                                                    x.label !== "gpt_bs" && x.label !== "px_bsRisk") ?
                                                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                                                        <Input placeholder="Search"
                                                                                                                            value={x.valueSearch}
                                                                                                                            onChange={(event) => {
                                                                                                                                handleChangeValueSearch(event, i)
                                                                                                                            }}
                                                                                                                            ref={getRef(`propertyseven-${i}`)}
                                                                                                                            prefix={<SearchOutlined className="search_icon_d2" />}
                                                                                                                        // allowClear 
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                    :
                                                                                                                    <></>
                                                                                                                }
                                                                                                                {menu}
                                                                                                            </>
                                                                                                        )}
                                                                                                    >

                                                                                                        {


                                                                                                            [
                                                                                                                ...filterRepeaterValueOptions_tagName?.filter(option => x.value?.includes(option.value)),
                                                                                                                ...filterRepeaterValueOptions_tagName?.filter(option => !x.value?.includes(option.value))
                                                                                                            ]

                                                                                                                ?.filter((option) =>
                                                                                                                    option.label.toLowerCase().includes(x.valueSearch?.toLowerCase() || '')
                                                                                                                )
                                                                                                                .map(option => (
                                                                                                                    <Option key={option.value} value={option.value}>
                                                                                                                        <div
                                                                                                                            onClick={() => handleChangeFilterValue(option.value, i, "")}
                                                                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                                                                        >
                                                                                                                            <Checkbox
                                                                                                                                checked={x.value?.includes(option.value)}
                                                                                                                                onClick={(e) => e.stopPropagation()}
                                                                                                                            >
                                                                                                                                {option.label}
                                                                                                                            </Checkbox>
                                                                                                                        </div>
                                                                                                                    </Option>
                                                                                                                ))}
                                                                                                    </Select>

                                                                                                </div>
                                                                                            }

                                                                                            {(x.label === "adcodes" || x.label === "m_lang" || x.label === "tld_co" || x.label === "gpt_geo" || x.label === "gpt_bs" || x.label === "px_ivtRisk" || x.label === "px_viewRisk" || x.label === "px_adult" || x.label === "px_alcohol" || x.label === "px_drug" || x.label === "px_speech" || x.label === "px_mfa" || x.label === "px_cat" || x.label === "px_bsRisk"
                                                                                            ) &&
                                                                                                <Select
                                                                                                    id="adcodeSelect"
                                                                                                    value={x.value}
                                                                                                    popupClassName='diff_select_d2 --filter_half'
                                                                                                    // open={true}
                                                                                                    showSearch={false}
                                                                                                    placeholder='- Select -'
                                                                                                    className={x.validation_value ? 'form_select basic error' : 'form_select basic'}
                                                                                                    mode='multiple'
                                                                                                    open={!!openSelectState[`propertyone-${i}`]}
                                                                                                    onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyone-${i}`, open)}
                                                                                                    maxTagCount='responsive'
                                                                                                    dropdownRender={menu => (
                                                                                                        <>
                                                                                                            {(
                                                                                                                x.label !== "gpt_bs" && x.label !== "px_bsRisk") ?
                                                                                                                <div className="custom_inside_searchbar_d2">
                                                                                                                    <Input placeholder="Search"
                                                                                                                        value={x.valueSearch}
                                                                                                                        onChange={(event) => {
                                                                                                                            handleChangeValueSearch(event, i)
                                                                                                                        }}
                                                                                                                        ref={getRef(`propertyone-${i}`)}
                                                                                                                        prefix={<SearchOutlined className="search_icon_d2" />}
                                                                                                                    // allowClear 
                                                                                                                    />
                                                                                                                </div>
                                                                                                                :
                                                                                                                <></>
                                                                                                            }
                                                                                                            {menu}
                                                                                                        </>
                                                                                                    )}
                                                                                                >

                                                                                                    {
                                                                                                        (x.label === "adcodes" ?
                                                                                                            [
                                                                                                                ...filterRepeaterValueOptions_adcodes?.filter(option => x.value?.includes(option.value)),
                                                                                                                ...filterRepeaterValueOptions_adcodes?.filter(option => !x.value?.includes(option.value))
                                                                                                            ]
                                                                                                            : x.label === "m_lang" ?
                                                                                                                [
                                                                                                                    ...filterRepeaterValueOptions_language_meta?.filter(option => x.value?.includes(option.value)),
                                                                                                                    ...filterRepeaterValueOptions_language_meta?.filter(option => !x.value?.includes(option.value))
                                                                                                                ]
                                                                                                                : x.label === "tld_co" ?
                                                                                                                    [
                                                                                                                        ...filterRepeaterValueOptions_country_tld?.filter(option => x.value?.includes(option.value)),
                                                                                                                        ...filterRepeaterValueOptions_country_tld?.filter(option => !x.value?.includes(option.value))
                                                                                                                    ]
                                                                                                                    : x.label === "gpt_geo" ?
                                                                                                                        [
                                                                                                                            ...filterRepeaterValueOptions_country_gpt?.filter(option => x.value?.includes(option.value)),
                                                                                                                            ...filterRepeaterValueOptions_country_gpt?.filter(option => !x.value?.includes(option.value))
                                                                                                                        ]
                                                                                                                        : x.label === "px_ivtRisk" ?
                                                                                                                            [
                                                                                                                                ...filterRepeaterValueOptions_px_ivtRisk?.filter(option => x.value?.includes(option.value)),
                                                                                                                                ...filterRepeaterValueOptions_px_ivtRisk?.filter(option => !x.value?.includes(option.value))
                                                                                                                            ]

                                                                                                                            : x.label === "px_viewRisk" ?
                                                                                                                                [
                                                                                                                                    ...filterRepeaterValueOptions_px_viewRisk?.filter(option => x.value?.includes(option.value)),
                                                                                                                                    ...filterRepeaterValueOptions_px_viewRisk?.filter(option => !x.value?.includes(option.value))
                                                                                                                                ]
                                                                                                                                : x.label === "px_adult" ?
                                                                                                                                    [
                                                                                                                                        ...filterRepeaterValueOptions_px_adult?.filter(option => x.value?.includes(option.value)),
                                                                                                                                        ...filterRepeaterValueOptions_px_adult?.filter(option => !x.value?.includes(option.value))
                                                                                                                                    ]
                                                                                                                                    : x.label === "px_alcohol" ?
                                                                                                                                        [
                                                                                                                                            ...filterRepeaterValueOptions_px_alcohol?.filter(option => x.value?.includes(option.value)),
                                                                                                                                            ...filterRepeaterValueOptions_px_alcohol?.filter(option => !x.value?.includes(option.value))
                                                                                                                                        ]
                                                                                                                                        : x.label === "px_drug" ?
                                                                                                                                            [
                                                                                                                                                ...filterRepeaterValueOptions_px_drug?.filter(option => x.value?.includes(option.value)),
                                                                                                                                                ...filterRepeaterValueOptions_px_drug?.filter(option => !x.value?.includes(option.value))
                                                                                                                                            ]
                                                                                                                                            : x.label === "px_speech" ?
                                                                                                                                                [
                                                                                                                                                    ...filterRepeaterValueOptions_px_speech?.filter(option => x.value?.includes(option.value)),
                                                                                                                                                    ...filterRepeaterValueOptions_px_speech?.filter(option => !x.value?.includes(option.value))
                                                                                                                                                ]
                                                                                                                                                : x.label === "px_mfa" ?
                                                                                                                                                    [
                                                                                                                                                        ...filterRepeaterValueOptions_px_mfa?.filter(option => x.value?.includes(option.value)),
                                                                                                                                                        ...filterRepeaterValueOptions_px_mfa?.filter(option => !x.value?.includes(option.value))
                                                                                                                                                    ]
                                                                                                                                                    : x.label === "px_cat" ?
                                                                                                                                                        [
                                                                                                                                                            ...filterRepeaterValueOptions_px_cat?.filter(option => x.value?.includes(option.value)),
                                                                                                                                                            ...filterRepeaterValueOptions_px_cat?.filter(option => !x.value?.includes(option.value))
                                                                                                                                                        ]
                                                                                                                                                        : x.label === "px_bsRisk" ?
                                                                                                                                                            [
                                                                                                                                                                ...filterRepeaterValueOptions_px_bsRisk?.filter(option => x.value?.includes(option.value)),
                                                                                                                                                                ...filterRepeaterValueOptions_px_bsRisk?.filter(option => !x.value?.includes(option.value))
                                                                                                                                                            ]
                                                                                                                                                            :
                                                                                                                                                            [
                                                                                                                                                                ...filterRepeaterValueOptions_brand_safety?.filter(option => x.value?.includes(option.value)),
                                                                                                                                                                ...filterRepeaterValueOptions_brand_safety?.filter(option => !x.value?.includes(option.value))
                                                                                                                                                            ]
                                                                                                        )?.filter((option) =>
                                                                                                            option.label.toLowerCase().includes(x.valueSearch?.toLowerCase() || '')
                                                                                                        )
                                                                                                            .map(option => (
                                                                                                                <Option key={option.value} value={option.value}>
                                                                                                                    <div
                                                                                                                        onClick={() => handleChangeFilterValue(option.value, i, "")}
                                                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                                                    >
                                                                                                                        <Checkbox
                                                                                                                            checked={x.value?.includes(option.value)}
                                                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                                                        >
                                                                                                                            {option.label}
                                                                                                                        </Checkbox>
                                                                                                                    </div>
                                                                                                                </Option>
                                                                                                            ))}
                                                                                                </Select>
                                                                                            }
                                                                                            {(x.label === "gpt_cat") &&

                                                                                                <div className="new_stretch_dropdown_d2">

                                                                                                    <Select
                                                                                                        id="adcodeSelect"
                                                                                                        popupClassName='diff_select_d2 --filter_half'
                                                                                                        className={x.validation_value ? 'form_select basic error' : 'form_select basic'}
                                                                                                        showSearch={false}
                                                                                                        // open={true}
                                                                                                        mode='multiple'
                                                                                                        placeholder='- Select -'
                                                                                                        open={!!openSelectState[`propertytwo-${i}`]}
                                                                                                        onDropdownVisibleChange={(open) => toggleSelectOpen(`propertytwo-${i}`, open)}
                                                                                                        // maxTagCount='responsive'
                                                                                                        value={x.value}
                                                                                                        dropdownRender={menu => (
                                                                                                            <>
                                                                                                                <div className="custom_inside_searchbar_d2">
                                                                                                                    <Input
                                                                                                                        placeholder="Type for search"
                                                                                                                        value={searchFilter_category[i].search}
                                                                                                                        onChange={(e) => handleSearchFilter_category(e.target.value, i)}
                                                                                                                        prefix={<SearchOutlined className="search_icon_d2" />}
                                                                                                                        ref={getRef(`propertytwo-${i}`)}
                                                                                                                    // allowClear
                                                                                                                    />
                                                                                                                </div>
                                                                                                                {menu}
                                                                                                            </>
                                                                                                        )}
                                                                                                    >
                                                                                                        {
                                                                                                            i === LoaderFilter_category.index && LoaderFilter_category.loading ?
                                                                                                                <div style={{ textAlign: "center", padding: "10px 0" }}>
                                                                                                                    <Spin size="small" />
                                                                                                                </div> :
                                                                                                                <>
                                                                                                                    {
                                                                                                                        [
                                                                                                                            ...x.options?.filter(option => x.value?.includes(option.value)),
                                                                                                                            ...x.options?.filter(option => !x.value?.includes(option.value))
                                                                                                                        ].map(option => (
                                                                                                                            <Option key={option.value} value={option.value}>
                                                                                                                                <div
                                                                                                                                    onClick={() => handleChangeFilterValue(option.value, i, "")}
                                                                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                                                                >
                                                                                                                                    <Checkbox
                                                                                                                                        checked={x.value?.includes(option.value)}
                                                                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                                                                    >
                                                                                                                                        {option.label}
                                                                                                                                    </Checkbox>
                                                                                                                                </div>
                                                                                                                            </Option>
                                                                                                                        ))
                                                                                                                    }
                                                                                                                </>
                                                                                                        }
                                                                                                    </Select>
                                                                                                </div>
                                                                                            }
                                                                                            {(x.label === "px_pp") &&
                                                                                                <div className="form_content_block--group">
                                                                                                    <Radio.Group className="form_radio equal_space"
                                                                                                        onChange={(event) => {
                                                                                                            handleChangeFilterValue(event, i, "px_pp")
                                                                                                        }}
                                                                                                        value={x.value}
                                                                                                    >
                                                                                                        <Radio className="radio_btn" value="yes">
                                                                                                            Yes
                                                                                                        </Radio>
                                                                                                        <Radio className="radio_btn" value="no">
                                                                                                            No
                                                                                                        </Radio>
                                                                                                    </Radio.Group>
                                                                                                </div>
                                                                                            }

                                                                                            {(x.label === "m_words") &&
                                                                                                <div className="form_content_block--group prefixed_icon_d2">
                                                                                                    <Input className={x.validation_value ? 'form_control basic error' : 'form_control basic'} placeholder='Enter comma separated values' autocomplete="off"
                                                                                                        value={x.value}
                                                                                                        onChange={(event) => { handleChangeFilterValue(event, i, "m_words") }}
                                                                                                    />
                                                                                                </div>
                                                                                            }
                                                                                            {(x.label === "pub_req" || x.label === "px_view" || x.label === "px_age" || x.label === "px_ivt") &&
                                                                                                <div className="w-100 d-flex justify-content-between publisher_select_rightleft_spacing_d2">
                                                                                                    <div className="form_content_block--group mb_0 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                                                        <Select
                                                                                                            id="adcodeSelect"
                                                                                                            showSearch={false}
                                                                                                            placeholder=""
                                                                                                            optionFilterProp="label"
                                                                                                            open={!!openSelectState[`propertythree-${i}`]}
                                                                                                            onDropdownVisibleChange={(open) => toggleSelectOpen(`propertythree-${i}`, open)}
                                                                                                            className='form_select basic '
                                                                                                            options={filterRepeaterConditionOptions_publisher_request}
                                                                                                            value={x.condition}
                                                                                                            onChange={(event) => { handleChangeFilterCondition(event, i) }}
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div style={{ width: 16 }}></div>
                                                                                                    <div className="form_content_block--group prefixed_icon_d2">
                                                                                                        <Input placeholder='Enter value' autocomplete="off"
                                                                                                            className={x.validation_value ? 'form_control basic error' : 'form_control basic'}
                                                                                                            value={x.value}
                                                                                                            onChange={(event) => { handleChangeFilterValue(event, i, "pub_req") }}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            }

                                                                                            {(x.label === "co_req" || x.label === "px_invByCo") &&
                                                                                                <Row gutter={8} className="single_select_placement_text_d2 last_one_fields_d2 align-items-center justify-content-between">
                                                                                                    <Col span={14} className="country_req_select_tag_d2 pe-0">
                                                                                                        <Select
                                                                                                            id="adcodeSelect"
                                                                                                            showSearch={true}
                                                                                                            // open={true}
                                                                                                            optionFilterProp="label"
                                                                                                            className={x.validation_value && x.other?.length === 0 ? 'form_select basic error w-100' : 'form_select basic w-100'}
                                                                                                            options={x.label === "co_req" ? filterRepeaterValueOptions_country_request : filterRepeaterValueOptions_px_invByCo}
                                                                                                            open={!!openSelectState[`propertyfour-${i}`]}
                                                                                                            onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyfour-${i}`, open)}
                                                                                                            value={x.other?.length > 0 ? x.other : undefined}
                                                                                                            onChange={(event) => { handleChangeFilterOther(event, i) }}
                                                                                                            placeholder="-Select Country-"
                                                                                                        />
                                                                                                    </Col>
                                                                                                    <Col className="px-0">
                                                                                                        <span className="is_text m-0 px-2">is</span>
                                                                                                    </Col>
                                                                                                    <Col span={4} className="ps-0">
                                                                                                        <div className="only_for_text_view_d2 form_content_block--group mb_0 equal_sign_dropdown_d2 hide_open_searchplaceholder_d2 hide_caret_after_select_value">
                                                                                                            <Select
                                                                                                                id="adcodeSelect"
                                                                                                                showSearch={false}
                                                                                                                placeholder=""
                                                                                                                // open={true}
                                                                                                                optionFilterProp="label"
                                                                                                                popupClassName='diff_select_d2 textvalue_select_d2 --value_with_para_text'
                                                                                                                className='form_select basic'
                                                                                                                open={!!openSelectState[`propertyfive-${i}`]}
                                                                                                                onDropdownVisibleChange={(open) => toggleSelectOpen(`propertyfive-${i}`, open)}
                                                                                                                options={filterRepeaterConditionOptions_country_request}
                                                                                                                value={x.condition}
                                                                                                                // value={filterRepeaterConditionOptions_country_request.find(option => option.value === x.condition)?.label}
                                                                                                                onChange={(event) => { handleChangeFilterCondition(event, i) }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                    {/* <Col>
                                                                                        <div style={{ width: 16 }}></div>
                                                                                    </Col> */}
                                                                                                    <Col span={5}>
                                                                                                        <div className="enter_no_input_d2">
                                                                                                            {x.label === "co_req" ?
                                                                                                                <Input placeholder='Enter no.' autocomplete="off"
                                                                                                                    className={x.validation_value && x.value?.length === 0 ? 'form_control basic w-100 error' : 'form_control basic w-100'}
                                                                                                                    value={x.value}
                                                                                                                    onChange={(event) => {
                                                                                                                        handleChangeFilterValue(event, i, "co_req")
                                                                                                                    }}
                                                                                                                />
                                                                                                                :
                                                                                                                <Input placeholder='Enter no.' autocomplete="off"
                                                                                                                    className={x.validation_value && x.value?.length === 0 ? 'form_control basic w-100 error' : 'form_control basic w-100'}
                                                                                                                    value={x.value}
                                                                                                                    onChange={(event) => {
                                                                                                                        handleChangeFilterValue(event, i, "px_invByCo")
                                                                                                                    }}
                                                                                                                />
                                                                                                            }
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            }

                                                                                        </div>
                                                                                        <div className='download_icon_d2 d-flex align-items-center justify-content-between'>
                                                                                            <img className='delete_form_icon' src={removeIcon} alt="Delete" onClick={() => handleRemoveFeedListRepeater(i)} />
                                                                                        </div>

                                                                                    </div>
                                                                                    {/* {(x.label === "adcodes" || x.label === "m_lang" || x.label === "tld_co" || x.label === "gpt_geo" || x.label === "gpt_bs" || x.label === "gpt_cat") &&
                                                                <span className="error_content">{x.validation_value && <>Minimum 1 selection is required</>} </span>
                                                            }
                                                            {(x.label === "m_words" || x.label === "pub_req" || x.label === "co_req") &&
                                                                <span className="error_content">{x.validation_value && <>This field is required</>} </span>
                                                            } */}
                                                                                </div>
                                                                            </Col>
                                                                        </Row>
                                                                    )
                                                                })}
                                                            </div>

                                                            <div className="adjust_padding_d2">
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <div className='addnewform_d2 addnewform_filter_d2 scroll_option_div'>
                                                                            <Dropdown className="inner_dropdown_btn_d2">
                                                                                <Dropdown.Toggle className="dropdown-autoclose-false px-2" id="dropdown-basic">
                                                                                    <img src={addIcon} className="m-0" alt='Add Property' /> Add Property
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("adcodes") }}>Adcodes</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("gpt_bs") }}>Brand Safety (GPT)</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("gpt_cat") }}>Categories (GPT)</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("gpt_geo") }}>Country (GPT)</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("tld_co") }}>Country (TLD)</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("co_req") }}>Country Request</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("m_words") }}>Keywords (Meta)</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("m_lang") }}>Language (Meta)</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("pub_req") }}>Publisher Request</Dropdown.Item>
                                                                                    <Dropdown.Item onClick={() => { handleAddFilterRepeater("tagName") }}>Tags</Dropdown.Item>

                                                                                </Dropdown.Menu>


                                                                            </Dropdown>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {filterRepeater.some(obj => obj.validation_value === true) && <span className="error_content">  Please fill all required fields </span>}
                                                                <hr />
                                                            </div>
                                                        </div>

                                                        { }

                                                        <div className="adjust_padding_d2">
                                                            <div className="filter_bottom_btns_d2 text-end">
                                                                <button className="reset" type='button' onClick={handleResetFilterRepeater}
                                                                // disabled={filterRepeater.length === 0}
                                                                >Reset</button>
                                                                <button className="apply" type='button' onClick={handleApplyFilterRepeater}
                                                                // disabled={filterRepeater.length === 0}
                                                                // disabled={JSON.stringify(filterRepeater) === JSON.stringify(filterApplyApiCall.filterArray) && filterApplyApiCall.connector === filterRepeaterConnectorValue}
                                                                >Apply</button>
                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            <div className={taggingShow ? "custom_media_filter_d2 mediaPlanner_filter tagging_filter active" : "custom_media_filter_d2 mediaPlanner_filter tagging_filter "}>

                                                <Dropdown className=""
                                                    show={taggingShow}
                                                    ref={dropdownRef1}
                                                    onToggle={() => {
                                                        setTaggingShow(!taggingShow);
                                                        document.querySelector('.tagging_filter_overlay').classList.toggle('active', !taggingShow);

                                                        if (taggingShow) {
                                                            setCssToggle(true)
                                                            setMediakit({});
                                                            setMediakitIsRequiredError(false);
                                                            setMarkedTag("Blacklist");
                                                            setButtonProcessingTagging(false)
                                                        }

                                                    }}
                                                    autoClose={false}>
                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                        <Dropdown.Toggle id="dropdown-autoclose-false px-2">
                                                            <Button className="" icon={
                                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M4.12963 4.13045H4.13589M12.636 8.14369L8.14808 12.6328C8.03182 12.7492 7.89375 12.8415 7.74178 12.9046C7.58981 12.9676 7.42691 13 7.26239 13C7.09788 13 6.93498 12.9676 6.78301 12.9046C6.63104 12.8415 6.49297 12.7492 6.37671 12.6328L1 7.2609V1H7.25926L12.636 6.37811C12.8691 6.61273 13 6.93009 13 7.2609C13 7.59171 12.8691 7.90908 12.636 8.14369Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }>
                                                                Tagging
                                                            </Button>
                                                        </Dropdown.Toggle>
                                                    </div>

                                                    <Dropdown.Menu style={{ height: cssToggle ? "355px" : "252px" }}

                                                    >
                                                        <div className="tagging_filter_content"
                                                            id="shakeDiv"
                                                        >
                                                            <Row gutter={16}>
                                                                <Col span={8}>

                                                                    <div className="form_content_block--group tagging_filter_input_block "
                                                                        style={{ height: cssToggle ? "182px" : "72px" }}
                                                                    >
                                                                        <div className="tagging_filter_input">
                                                                            {cssToggle &&
                                                                                <>

                                                                                    <label for='file0040' className='ant_upload_drag'>
                                                                                        <p className="upload_drag_icon">
                                                                                            <img src={uploadIcon} alt='USP' />
                                                                                        </p>
                                                                                        <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                                                        <p className="ant_upload_hint">
                                                                                            .csv (max. 1000 Domains)
                                                                                        </p>
                                                                                    </label>
                                                                                    <input className='form_upload d-none' type="file"
                                                                                        name="file0040"
                                                                                        id="file0040"
                                                                                        accept=".csv"
                                                                                        onChange={onChangeMediakit}
                                                                                    />
                                                                                </>
                                                                            }

                                                                            {!cssToggle &&


                                                                                <div className="ant_upload_list--item " >
                                                                                    <div className="ant_upload_list--content">
                                                                                        <img src={csvImage} alt="" />


                                                                                        <div className="ant_upload_list--info">
                                                                                            <span className="ant_upload_list--info-name">
                                                                                                {mediakit.filename?.length > 38 ? <>{mediakit.filename?.slice(0, 38)}...</> : <>{mediakit.filename}</>}

                                                                                            </span>
                                                                                            <span className="ant_upload_list--info-size">
                                                                                                {mediakit.size / 1024 > 100 ? `${(mediakit.size / (1024 * 1024)).toFixed(2)} MB` : `${(mediakit.size / (1024)).toFixed(2)} KB`}
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <button type="link" className="ant_upload_list--delete"
                                                                                        onClick={() => {
                                                                                            setMediakit({})
                                                                                            setCssToggle(!cssToggle)
                                                                                        }}
                                                                                    >
                                                                                        <img src={deleteIcon} alt="USP" />
                                                                                    </button>
                                                                                </div>
                                                                            }

                                                                            {cssToggle &&
                                                                                <>
                                                                                    <div className="tagging_filter_sample_download ">
                                                                                        <div
                                                                                            onClick={handleDownload}
                                                                                        >
                                                                                            <div className="download_box">
                                                                                                <img src={downloadCsvIcon} alt="" />

                                                                                                <p>Download CSV Template</p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    <span className="error_content">
                                                                                        {mediakitIsReqiredError &&
                                                                                            <>This field is required</>
                                                                                        }
                                                                                    </span>
                                                                                </>
                                                                            }
                                                                        </div>
                                                                    </div>

                                                                </Col>
                                                            </Row>

                                                            <Row gutter={16}
                                                                style={{ marginTop: !cssToggle ? "10px" : "0px" }}
                                                            >
                                                                <Col span={24}>
                                                                    <div className="form_content_block--group mb_0  "

                                                                    >
                                                                        <label className='form_label'>Select Tag *</label>
                                                                        <Select
                                                                            id="adcodeSelect2"
                                                                            optionFilterProp="label"
                                                                            className="form_select basic no_search"
                                                                            value={markedTag}
                                                                            onChange={onChangeMarkedTag}
                                                                            options={markedTagOptions}
                                                                        >
                                                                        </Select>

                                                                        <span className="error_content">
                                                                            <></>
                                                                        </span>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                            <hr />



                                                            <div className="d_flex justify_content_between tagging_filter_footer">
                                                                <div className="d_flex justify_content_start align_items_center"
                                                                // style={{ opacity: buttonProcessingTagging ? "0" : "1" }}
                                                                >
                                                                    {/* <img src={iconProcessingRequest} alt="" />

                                                        <p >Processing request ...</p> */}

                                                                    <div className="domain_history_button" >
                                                                        <a href="/tagHistory" target="_blank">
                                                                            <img src={historyButton} alt="" />
                                                                        </a>
                                                                    </div>
                                                                </div>

                                                                {buttonProcessingTagging ?
                                                                    <>
                                                                        <div className=" filter_bottom_btns_d2 text-end">
                                                                            <button className="reset" type='button'>Discard</button>
                                                                            <button
                                                                                className="btn btn_primary w_fit_content loader apply loader"
                                                                            >
                                                                                <span>Submit</span>

                                                                                <img
                                                                                    src={loaderIcon}
                                                                                    alt="USP"
                                                                                    className="loader_icon"
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className=" filter_bottom_btns_d2 text-end">
                                                                            <button className="reset" type='button'
                                                                                onClick={() => {
                                                                                    resetStatesTagging()
                                                                                }}

                                                                            >Discard</button>
                                                                            <button className="apply" type='button'
                                                                                onClick={handSubmitTagging}

                                                                            >Submit</button>
                                                                        </div>
                                                                    </>

                                                                }

                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            <div className={checkAdcodesShow ? "custom_media_filter_d2 mediaPlanner_filter check_addcodes_dropdown active" : "custom_media_filter_d2 mediaPlanner_filter check_addcodes_dropdown "} >

                                                <Dropdown className=""
                                                    show={checkAdcodesShow}
                                                    ref={dropdownRef2}
                                                    onToggle={() => {
                                                        setCheckAdcodesShow(!checkAdcodesShow);
                                                        document.querySelector('.tagging_filter_overlay').classList.toggle('active', !checkAdcodesShow);

                                                        if (checkAdcodesShow) {
                                                        }

                                                    }}
                                                    autoClose={false}>
                                                    <div className="position-relative hover_effec_hide_show_d2">
                                                        <Dropdown.Toggle id="dropdown-autoclose-false px-2">
                                                            {/* <span style={{ transform: "translateY(1px)" }}></span> */}
                                                            <Button className="" icon={
                                                                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M9.5 2.5V6H13" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M9.25 8.5L10.75 10L9.25 11.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M6.75 8.5L5.25 10L6.75 11.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M12.5 14.5C12.6326 14.5 12.7598 14.4473 12.8536 14.3536C12.9473 14.2598 13 14.1326 13 14V6L9.5 2.5H3.5C3.36739 2.5 3.24021 2.55268 3.14645 2.64645C3.05268 2.74021 3 2.86739 3 3V14C3 14.1326 3.05268 14.2598 3.14645 14.3536C3.24021 14.4473 3.36739 14.5 3.5 14.5H12.5Z" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }>
                                                                Check Adcodes
                                                            </Button>
                                                        </Dropdown.Toggle>
                                                    </div>

                                                    <Dropdown.Menu style={{ height: cssToggleCheckCodes ? "355px" : "252px" }}
                                                    >
                                                        <div className="tagging_filter_content"
                                                            id="shakeDiv2"
                                                        >
                                                            <Row gutter={16}>
                                                                <Col span={8}>

                                                                    <div className="form_content_block--group tagging_filter_input_block "
                                                                    >

                                                                        {cssToggleCheckCodes &&

                                                                            <div className="tagging_filter_input">

                                                                                <label for='file0045' className='ant_upload_drag'>
                                                                                    <p className="upload_drag_icon">
                                                                                        <img src={uploadIcon} alt='USP' />
                                                                                    </p>
                                                                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                                                                    <p className="ant_upload_hint">
                                                                                        .csv (max. 10,000 Domains)
                                                                                    </p>
                                                                                </label>
                                                                                <input className='form_upload d-none' type="file"
                                                                                    name="file0045"
                                                                                    id="file0045"
                                                                                    accept=".csv"
                                                                                    onChange={onChangeMediakitCheckAdcodes}
                                                                                />
                                                                            </div>

                                                                        }

                                                                        {!cssToggleCheckCodes &&


                                                                            <div className="ant_upload_list--item " >
                                                                                <div className="ant_upload_list--content">
                                                                                    <img src={csvImage} alt="" />


                                                                                    <div className="ant_upload_list--info">
                                                                                        <span className="ant_upload_list--info-name">
                                                                                            {mediakitCheckAdcodes.filename?.length > 38 ? <>{mediakitCheckAdcodes.filename?.slice(0, 38)}...</> : <>{mediakitCheckAdcodes.filename}</>}

                                                                                        </span>
                                                                                        <span className="ant_upload_list--info-size">
                                                                                            {mediakitCheckAdcodes.size / 1024 > 100 ? `${(mediakitCheckAdcodes.size / (1024 * 1024)).toFixed(2)} MB` : `${(mediakitCheckAdcodes.size / (1024)).toFixed(2)} KB`}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <button type="link" className="ant_upload_list--delete"
                                                                                    onClick={() => {
                                                                                        setMediakitCheckAdcodes({})
                                                                                        setCssToggleCheckCodes(!cssToggleCheckCodes)
                                                                                    }}
                                                                                >
                                                                                    <img src={deleteIcon} alt="USP" />
                                                                                </button>
                                                                            </div>
                                                                        }

                                                                        {cssToggleCheckCodes &&
                                                                            <>
                                                                                <div className="tagging_filter_sample_download ">
                                                                                    <div
                                                                                        onClick={handleDownloadCheckAdcodes}
                                                                                    >
                                                                                        <div className="download_box">
                                                                                            <img src={downloadCsvIcon} alt="" />

                                                                                            <p>Download CSV Template</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <span className="error_content">
                                                                                    {mediakitCheckAdcodesIsReqiredError &&
                                                                                        <>This field is required</>
                                                                                    }
                                                                                </span>
                                                                            </>
                                                                        }
                                                                    </div>


                                                                </Col>
                                                            </Row>


                                                            <Row gutter={16}>

                                                                <Col span={24}

                                                                >
                                                                    <div className="form_content_block--group mb_0">
                                                                        <label className="form_label">Adcodes *</label>
                                                                    </div>
                                                                    <div style={{ maxHeight: "42rem", overflow: "auto" }}>
                                                                        {filterGroups.map((group, groupIndex) => (
                                                                            <div
                                                                                className="form_content_block--group mb_0"
                                                                                style={{ position: "relative", marginBottom: 24 }}
                                                                                key={groupIndex}
                                                                            >

                                                                                <div style={{ position: "relative" }}>

                                                                                    <div className="check_adcodes_custom_input">
                                                                                        <div className="d_flex flex_wrap">
                                                                                            {group.map((item, index) => (
                                                                                                <React.Fragment key={`${groupIndex}-${index}`}>
                                                                                                    {index > 0 && (
                                                                                                        <div className="comma_container">
                                                                                                            <span className="comma">,</span>
                                                                                                        </div>
                                                                                                    )}

                                                                                                    <div className="d_flex flex_column">
                                                                                                        <div className="position">
                                                                                                            <Input
                                                                                                                id={`width_adcode_${groupIndex}_${index}`}
                                                                                                                className={
                                                                                                                    index === 0 && !item.validation
                                                                                                                        ? "check_adcode_input first"
                                                                                                                        : index === 0 && item.validation
                                                                                                                            ? "check_adcode_input first error"
                                                                                                                            : item.validation
                                                                                                                                ? "check_adcode_input error"
                                                                                                                                : "check_adcode_input"
                                                                                                                }
                                                                                                                value={item.value}
                                                                                                                onChange={(event) =>
                                                                                                                    handleFilterCheckAdCodesValue(event, `width_adcode_${groupIndex}_${index}`, groupIndex, index)
                                                                                                                }
                                                                                                                placeholder={
                                                                                                                    index === 0
                                                                                                                        ? "dailymotion.com"
                                                                                                                        : index === 1
                                                                                                                            ? "12345"
                                                                                                                            : ""
                                                                                                                }
                                                                                                                autoComplete="off"
                                                                                                            />
                                                                                                            {index > 1 && (
                                                                                                                <img
                                                                                                                    className="check_adcodes_minus"
                                                                                                                    src={AddCodesMinus}
                                                                                                                    alt=""
                                                                                                                    onClick={() => removeFilterCheckAdCodes(groupIndex, index)}
                                                                                                                />
                                                                                                            )}
                                                                                                        </div>

                                                                                                        {item.value.length > 0 && (
                                                                                                            <>
                                                                                                                {!isNaN(item.value) && !isNaN(parseFloat(item.value)) ? (
                                                                                                                    <Radio.Group
                                                                                                                        className="check_adcode_container"
                                                                                                                        value={item.condition}
                                                                                                                        onChange={(event) =>
                                                                                                                            handleFilterCheckAdCodesCondition(event, "radio", groupIndex, index)
                                                                                                                        }
                                                                                                                    >
                                                                                                                        <Radio
                                                                                                                            className="radio_btn check_adcode_radio"
                                                                                                                            value="direct"
                                                                                                                        >
                                                                                                                            Direct
                                                                                                                        </Radio>
                                                                                                                        <Radio
                                                                                                                            className="radio_btn check_adcode_radio"
                                                                                                                            value="regex"
                                                                                                                        >
                                                                                                                            Regex
                                                                                                                        </Radio>
                                                                                                                    </Radio.Group>
                                                                                                                ) : (
                                                                                                                    <div className="primary_checkbox">
                                                                                                                        <Checkbox
                                                                                                                            id="case_sensitive"
                                                                                                                            name="case_sensitive"
                                                                                                                            className="check_adcode_checkbox"
                                                                                                                            checked={item.condition === "case sensitive"}
                                                                                                                            onChange={(event) =>
                                                                                                                                handleFilterCheckAdCodesCondition(event, "checkbox", groupIndex, index)
                                                                                                                            }
                                                                                                                        >
                                                                                                                            <span className="form_label">
                                                                                                                                Case Sensitive Search
                                                                                                                            </span>
                                                                                                                        </Checkbox>
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </React.Fragment>
                                                                                            ))}

                                                                                            <div className="check_adcodes_container">
                                                                                                <img
                                                                                                    className="check_adcodes_add2"
                                                                                                    src={AddCodesAdd}
                                                                                                    alt="add"
                                                                                                    onClick={() => addFilterCheckAdCodes(groupIndex)}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Remove Group Button */}
                                                                                    {filterGroups?.length > 1 &&
                                                                                        <button
                                                                                            style={{ position: "absolute", top: "1.5rem", right: "1rem" }}
                                                                                            type="link" className="ant_upload_list--delete"
                                                                                            onClick={() => removeFilterGroup(groupIndex)}
                                                                                        >
                                                                                            <img src={deleteIcon} alt="USP" />
                                                                                        </button>
                                                                                    }
                                                                                </div>



                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                    {/* Add New Group Button */}

                                                                </Col>
                                                            </Row>

                                                            {filterGroups.length < 5 &&
                                                                <Row>
                                                                    <Col span={24}>
                                                                        <img src={AddNewAdcodesImg} onClick={addFilterGroup}
                                                                            style={{ cursor: "pointer" }}
                                                                            alt='Add New' />

                                                                    </Col>
                                                                    {filterCheckAdcodesIsRequiredError && (
                                                                        <span className="error_content error_input_container">
                                                                            Please fill all input fields
                                                                        </span>
                                                                    )}
                                                                </Row>
                                                            }



                                                            <hr />



                                                            <div className="d_flex justify_content_between tagging_filter_footer">
                                                                <div className="d_flex justify_content_start align_items_center"
                                                                >

                                                                    <div className="domain_history_button" >
                                                                        <a href="/adcodesHistory" target="_blank">
                                                                            <img src={historyButton} alt="" />
                                                                        </a>
                                                                    </div>
                                                                </div>

                                                                {buttonProcessingCheckAdcodes ?
                                                                    <>
                                                                        <div className="filter_bottom_btns_d2 text-end">
                                                                            <button className="reset" type='button'>Discard</button>


                                                                            <button className={checkAdcodesSubmitType === "submit" ? "apply button_middle loader_footer width_submit" : "apply button_middle width_submit"}
                                                                                style={{ pointerEvents: "none" }}
                                                                            >
                                                                                <span>Submit</span>

                                                                                {checkAdcodesSubmitType === "submit" &&
                                                                                    <img
                                                                                        src={FullLoader}
                                                                                        alt="USP"
                                                                                        className="loader_icon"
                                                                                    />
                                                                                }
                                                                            </button>

                                                                            <button
                                                                                className={checkAdcodesSubmitType === "submit_and_start" ? "apply  loader_footer2 width_start" : "apply  width_start"}
                                                                                style={{ pointerEvents: "none" }}

                                                                            >
                                                                                <span>Submit & Start</span>
                                                                                {checkAdcodesSubmitType === "submit_and_start" &&
                                                                                    <img
                                                                                        src={loaderIcon}
                                                                                        alt="USP"
                                                                                        className="loader_icon"
                                                                                    />
                                                                                }
                                                                            </button>
                                                                        </div>


                                                                    </>
                                                                    :
                                                                    <>
                                                                        <div className="filter_bottom_btns_d2 text-end">
                                                                            <button className="reset" type='button'
                                                                                onClick={() => {
                                                                                    resetStatesCheckAdcodes()
                                                                                }}

                                                                            >Discard</button>
                                                                            <button className="apply button_middle" type='button'
                                                                                onClick={() => { handleSubmitCheckAdcodes("submit") }}

                                                                            >Submit</button>
                                                                            <button className="apply" type='button'
                                                                                onClick={() => { handleSubmitCheckAdcodes("submit_and_start") }}

                                                                            >Submit & Start</button>
                                                                        </div>
                                                                    </>

                                                                }

                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            {!hasXapadsInAdcodes(filterApplyApiCall.filterArray) ?
                                                <div className="export_btn_hover_d2">

                                                    {exportMediaPlannerLoading ?
                                                        <Button
                                                            className="export_btn_d2"
                                                            icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                    <g clip-path="url(#clip0_11006_24214)">
                                                                        <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_11006_24214">
                                                                            <rect width="14" height="14" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            }>
                                                            Export
                                                        </Button> :
                                                        data.length === 0 ?
                                                            <Button

                                                                className="export_btn_d2"
                                                                icon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <g clip-path="url(#clip0_11006_24214)">
                                                                            <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_11006_24214">
                                                                                <rect width="14" height="14" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }>
                                                                Export
                                                            </Button>
                                                            :
                                                            <Button
                                                                style={{ transform: "tranlateY(-0.3rem)" }}
                                                                onClick={exportMediaPlanner}
                                                                className="export_btn_d2"
                                                                icon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                        <g clip-path="url(#clip0_11006_24214)">
                                                                            <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                            <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </g>
                                                                        <defs>
                                                                            <clipPath id="clip0_11006_24214">
                                                                                <rect width="14" height="14" fill="white" />
                                                                            </clipPath>
                                                                        </defs>
                                                                    </svg>
                                                                }>
                                                                Export
                                                            </Button>
                                                    }
                                                </div>
                                                :
                                                <div className="export_btn_hover_d2 export_child_dropdown">

                                                    <Dropdown
                                                        ref={dropdownExportRef}
                                                        show={exportShow}
                                                        onToggle={() => {
                                                            if (data.length !== 0) {
                                                                setExportShow(!exportShow);
                                                            }

                                                            // if (taggingShow) {
                                                            //     setCssToggle(true)
                                                            //     setMediakit({});
                                                            //     setMediakitIsRequiredError(false);
                                                            //     setMarkedTag("Blacklist");
                                                            //     setButtonProcessingTagging(false)
                                                            // }

                                                        }}
                                                        autoClose={false}>
                                                        <div className="position-relative hover_effec_hide_show_d2">
                                                            <Dropdown.Toggle id="dropdown-autoclose-false px-2">
                                                                {exportMediaPlannerLoading ?
                                                                    <img
                                                                        src={FullLoader}
                                                                        alt="USP"
                                                                        height={15}
                                                                        width={15}
                                                                        className="loader_icon"
                                                                    /> :
                                                                    <img src={mediaKitIcon} alt='' />
                                                                }
                                                                Export
                                                            </Dropdown.Toggle>
                                                        </div>

                                                        <Dropdown.Menu >
                                                            <div className="export_child_menu">
                                                                <ul>
                                                                    <li className="d_flex align_items_center"
                                                                        onClick={() => { exportMediaPlanner(); setExportShow(false) }}
                                                                    >
                                                                        <img src={ExportMenu1} alt="" />
                                                                        Export

                                                                    </li>
                                                                    <li className="d_flex align_items_center"
                                                                        onClick={() => {
                                                                            handleExportWithChildModalOpen()
                                                                        }}
                                                                    >
                                                                        <img src={ExportMenu2} alt="" />

                                                                        Export with child
                                                                    </li>
                                                                </ul>

                                                            </div>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>

                                            }


                                            <div className="column_hide_unhide_d3 column_hide_unhide_mediaplanner_d2">
                                                <Dropdown className="" autoClose="outside">
                                                    <Dropdown.Toggle id="dropdown-autoclose-outside">
                                                        <Button className="" icon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                <path d="M1.5 3H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.5 3H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M1.5 7H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.5 7H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M1.5 11H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8.5 11H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }>
                                                            Columns
                                                        </Button>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <div className="colunm_checkbox">
                                                            <ul className="p-0 m-0"

                                                            >
                                                                <li
                                                                >
                                                                    <label htmlFor="select_all_adcodes">
                                                                        <input
                                                                            className={isIndeterminate(colvis) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                                            type="checkbox"
                                                                            id="select_all_adcodes"
                                                                            checked={Object.values(colvis).every(value => value === true)}
                                                                            onChange={(e) => {
                                                                                const updatedObj = Object.keys(colvis).reduce((acc, key) => {
                                                                                    acc[key] = e.target.checked;
                                                                                    return acc;
                                                                                }, {});

                                                                                setColvis(updatedObj);
                                                                            }}
                                                                        />
                                                                        <span>
                                                                            < >Select All</>
                                                                        </span>
                                                                    </label>
                                                                </li>
                                                                <hr className="new_item_line_d3" />

                                                            </ul>
                                                            <ul
                                                                className="p-0 m-0 colvis_scroll"
                                                            >
                                                                <Row >
                                                                    {filterRepeaterValueOptions_colvis.map(({ label, value }) => (
                                                                        <Col span={8}>
                                                                            <li key={value}>
                                                                                <label htmlFor={value}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={value}
                                                                                        checked={colvis[value]}
                                                                                        onChange={() => {
                                                                                            const tempData = { ...colvis };
                                                                                            tempData[value] = !tempData[value];
                                                                                            setColvis(tempData);
                                                                                        }}
                                                                                    />
                                                                                    <span> {label?.length >= 50 ?
                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                        < >{label}</>}
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                        </Col>
                                                                    ))}

                                                                    <hr className="new_item_line_d3" />


                                                                    {filterRepeaterValueOptions_adcodes.map(({ label, value }) => (
                                                                        <Col span={8}>
                                                                            <li key={value}>
                                                                                <label htmlFor={value}>
                                                                                    <input
                                                                                        className="form-check-input"
                                                                                        type="checkbox"
                                                                                        id={value}
                                                                                        checked={colvis[value]}
                                                                                        onChange={() => {
                                                                                            const tempData = { ...colvis };
                                                                                            tempData[value] = !tempData[value];
                                                                                            setColvis(tempData);
                                                                                        }}
                                                                                    />
                                                                                    <span> {label?.length >= 50 ?
                                                                                        <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                                                        < >{label}</>}
                                                                                    </span>
                                                                                </label>
                                                                            </li>
                                                                        </Col>
                                                                    ))}
                                                                </Row>

                                                            </ul>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>



                        <div className="table_content--box --new_layout_table_design">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ x: 1500, y: 'calc(100vh - 31.5rem' }} />

                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${addCommasToNumber(page.total)} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>

            </div >

            <Modal
                className='custom_modal custom_modal_form_d2'
                visible={isModalVisibleCountryRequest}
                onOk={closeModalCountryRequest}
                width={1080}
                onCancel={closeModalCountryRequest}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'><h3 className='heading'><img src={macrosicon} alt='USP' /> {modalCountryRequest_Preview_Type === "domains" ? "Sub Domains (PX)" : "Country Wise Request"}</h3>
                    </div>
                }
                closable={true} // This removes the default close button
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_end d-none">
                        <div className="btn_group justify-content-end gap_8">
                            <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModalCountryRequest}> Discard </button>
                            <button className="w_120_d2 btn btn_primary w_fit_content">Create</button>
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className='all_macros_tag_d2 scrollable_tooltip_data_div_d2'>
                        <Row gutter={8}>

                            {modalCountryRequest_Preview_Type === "domains" ?
                                <>
                                    {modalCountryRequest_Preview?.map((item, index) => (
                                        <Col span={12} key={index}>
                                            <ul>
                                                <li>
                                                    <div className='text_ellipsis d-block anchor_tag_d2'><a href={item.includes("https://") ? item : "https://" + item} className="anchor_text_link_d2" target="_blank" rel="noreferrer">{item}</a></div>
                                                </li>
                                            </ul>
                                        </Col>

                                    ))}
                                </>
                                :
                                <>
                                    {modalCountryRequest_Preview?.map((item, index) => (
                                        <Col span={12} key={index}>
                                            <ul>
                                                <li>
                                                    {item.country} – <span> {addCommasToNumber(item.value)}</span>
                                                </li>
                                            </ul>
                                        </Col>

                                    ))}
                                </>
                            }
                        </Row>

                    </div>
                </div>
            </Modal>


            <Modal className='custom_modal custom_modal_form_d2'
                title={
                    <div className='custom_modal--header'>
                        <div className="d_flex justify_content_between">

                            <h3 className='heading' >
                                <img src={uploadFileIcon} alt='USP' /> Add Domains
                            </h3>
                            <div className="domain_history_button" style={{ marginRight: "2.8rem" }} >
                                <a href="/domainHistory" target="_blank">
                                    <img src={historyButton} alt="" />
                                </a>
                            </div>
                        </div>
                    </div>
                }
                visible={isModalVisible}
                onCancel={closeModal}
                closable={true}
                maskClosable={false}
                width={770}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_between publisher_domain_upload_footer">
                        <div className="d_flex justify_content_start align_items_center"
                        // style={{ opacity: buttonProcessing ? "1" : "0" }}
                        >
                            {/* <img src={iconProcessingRequest} alt="" />
                            <p >Processing request ...</p> */}
                        </div>
                        <div className="btn_group justify-content-end gap_8">
                            {buttonProcessing ?
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    >
                                        Discard
                                    </button>
                                    <button
                                        className="w_120_d2 btn btn_primary w_fit_content loader"

                                    >
                                        <span>Upload</span>

                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>
                                </> :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeModal}> Discard </button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmitModal}>Upload</button>
                                </>
                            }
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body">
                    <div className="tab_content--body">
                        <div className="form_content_block--group modal_form_bottom_gap_d2">
                            <label className="form_label">Publisher *</label>
                            <Select
                                showSearch
                                optionLabelProp="label"
                                className={publisherIsRequiredError ? 'form_select basic error' : 'form_select basic '}
                                placeholder="-Select-"
                                options={publisherOptions}
                                value={publisher}
                                onChange={onChangePublisher}
                            >
                            </Select>
                            <span className="error_content"> {publisherIsRequiredError && <>  This field is required</>}
                            </span>
                        </div>
                        {file?.filename === "" &&
                            <div className="form_content_block--group publisher_domain_upload">
                                {/* <label className="form_label">File *</label> */}
                                <label for='filepublisherDomain01' className='ant_upload_drag'>
                                    <p className="upload_drag_icon">
                                        <img src={uploadIcon} alt='USP' />
                                    </p>
                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> </p>

                                    <p className="ant_upload_hint ">
                                        CSV (max. 1000 Domains)
                                    </p>
                                    <p className="ant_upload_hint">
                                        Domains must be without <span className="text_highlight_span">http/https</span> and <span className="text_highlight_span">www</span>.
                                    </p>
                                </label>
                                <input className='form_upload d-none' type="file" id="filepublisherDomain01" name="filepublisherDomain01"
                                    accept=".csv"
                                    onChange={onChangeFile}
                                />
                                <div
                                    className="publisher_domain_sample_download"
                                >
                                    <div
                                        onClick={handleDownload}
                                    >
                                        <div className="publisher_domain_download_box">
                                            <img src={downloadCsvIcon} alt="" />

                                            <p>Download CSV Template</p>
                                        </div>
                                    </div>
                                </div>

                                <span className="error_content"> {fileIsRequiredError && <>  This field is required</>}
                                </span>
                            </div>
                        }
                        {file?.filename !== "" &&
                            <div className="ant_upload_list--item mb-0 mt-4">
                                <div className="ant_upload_list--content">
                                    {file.type !== "" ? <>
                                        {file.type === "text/plain" ?
                                            <img src={txtIcon} alt="USP" />
                                            :
                                            <img src={csvIcon} alt="USP" />

                                        }
                                    </> : <></>}

                                    <div className="ant_upload_list--info">
                                        <span className="ant_upload_list--info-name">{file.filename}</span>
                                        {/* <span className="ant_upload_list--info-size">{file.size !== "" ? <>{file.size?.toFixed(2)}  MB</> : <></>}</span> */}
                                        <span className="ant_upload_list--info-size">{file.size !== "" ?
                                            file.size < 1 ?
                                                (file.size * 1024) < 1 ?
                                                    <>{(file.size * 1024 * 1024)} Bytes </> :
                                                    <>{(file.size * 1024)?.toFixed(2)} KB </> :
                                                <>{file.size?.toFixed(2)}  MB</> :
                                            <></>}</span>
                                    </div>
                                </div>
                                <button type="link" className="ant_upload_list--delete download_icon_d2"
                                    onClick={() => {
                                        setFile({
                                            data: "",
                                            filename: "",
                                            ext: "",
                                            size: ""
                                        })
                                    }}
                                >
                                    <img src={deleteIcon} alt="USP" />
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </Modal>

            <Modal
                className='custom_modal custom_modal_form_d2 modal_child_export'
                visible={modalChildExportShow}
                width={1080}
                onCancel={handleModalChildExportModalClose}
                maskClosable={false}
                title={
                    <div className='custom_modal--header'><h3 className='heading'>
                        <img src={ExportWithChild} alt='USP' />
                        <span
                        > Export with Child
                        </span>

                    </h3>

                    </div>
                }
                closable={true}
                footer={[
                    <div className="custom_modal--footer d_flex justify_content_between publisher_domain_upload_footer">
                        <div className="d_flex justify_content_start align_items_center"
                        // style={{ opacity: buttonProcessing ? "1" : "0" }}
                        >
                            {/* <img src={iconProcessingRequest} alt="" />
                            <p >Processing request ...</p> */}
                        </div>
                        <div className="btn_group justify-content-end gap_8 export_combined" >
                            {childMappingButtonProcessing ?
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    >
                                        DISCARD
                                    </button>
                                    <button className={childExportType === "combined" ? "w_120_d3 btn btn_white_outline w_fit_content loader" : "w_120_d3 btn btn_white_outline w_fit_content"}
                                        style={{ pointerEvents: "none" }}
                                    >
                                        <span>EXPORT</span>

                                        <img
                                            src={FullLoader}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>
                                    <button
                                        className={childExportType === "zip" ? "w_120_d2 btn btn_primary w_fit_content loader" : "w_120_d2 btn btn_primary w_fit_content "}
                                        style={{ pointerEvents: "none" }}

                                    >
                                        <span>EXPORT ZIP</span>

                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>
                                </> :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={handleModalChildExportModalClose}> DISCARD </button>
                                    <button className='btn btn_white_outline w_fit_content footer_config d-flex gap_5  justify_content_center align_items_center'
                                        // disabled={!(childMappingData.filter(obj => obj.check).length > 0)}
                                        style={{ pointerEvents: !(childMappingData.filter(obj => obj.check).length > 0) ? "none" : "", opacity: !(childMappingData.filter(obj => obj.check).length > 0) ? "0.5" : "1" }}
                                        onClick={() => { exportMediaPlannerWithChild("combined") }}
                                    >EXPORT</button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content"
                                        disabled={!(childMappingData.filter(obj => obj.check).length > 0)}
                                        onClick={() => { exportMediaPlannerWithChild("zip") }}
                                    >EXPORT ZIP</button>
                                </>
                            }
                        </div>
                    </div>
                ]}
            >
                <div className="custom_modal--body"
                >
                    <div className='all_macros_tag_d2'>

                        <div className="export_display_message">
                            <div
                            >
                                <div className="download_box">
                                    <img src={iconProcessingRequest} alt="" />

                                    <p>You’re about to queue a large amount of data that may take a while to export and appear in your email.</p>
                                </div>
                            </div>
                        </div>

                        <Col span={24}>
                            <div className="form_content_block--group " >
                                <label className="form_label">Select Adcodes </label>
                            </div>
                        </Col>
                        <div className="d_flex justify_content_between  mb_10">
                            <div className="form_content_block--group">

                                <Input
                                    type='text'
                                    className='form_control basic md search_input w_table_search'
                                    placeholder="Search ID"
                                    value={searchChildMapping}
                                    onChange={handleSearchChildMapping}
                                />

                            </div>
                            {childMappingData.filter(obj => obj.check).length > 0 &&
                                <span className="export_selected_items">{childMappingData.filter(obj => obj.check).length}/{childMappingData.length} selected</span>
                            }
                            <div className="export_btn_hover_d2"
                                style={{ paddingLeft: "12px" }}
                            >
                                {childMappingData.length === 0 ?
                                    <Button
                                        className="export_btn_d3"
                                        style={{ pointerEvents: "none" }}
                                    >
                                        <img src={mediaKitIcon} alt='' />

                                    </Button>
                                    :
                                    <CSVLink
                                        headers={[{ label: "ID", key: "id" }, { label: "Count", key: "count" }]}
                                        data={childMappingData}
                                        filename={"Adcodes_" + new Date().getTime() + ".csv"}
                                        className="export_report"
                                    >
                                        <button className="export_btn_d3"
                                        >
                                            <img src={mediaKitIcon} alt=''
                                            />

                                        </button>
                                    </CSVLink>
                                }
                            </div>

                        </div>
                        <div className="table_content--box child_export_table"
                        >
                            {modalChildExportShow &&
                                <Table
                                    columns={childMappingColumns}
                                    dataSource={childMappingData?.filter(item => item.id.toString().includes(searchChildMapping))}
                                    // dataSource={childMappingData}
                                    locale={localeChildMapping}
                                    rowClassName={(record) => record.check ? 'table_row_checked_d3' : ''}
                                    pagination={false}
                                    scroll={{ x: '', y: 'calc(100vh - 50rem' }}
                                    onChange={handleTableChangeChild}
                                />
                            }

                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};

export default MediaPlanner;
